import spellIcons from "./spellIcons";

const spellDB = {
  T8_HEAD_CLOTH_SET1: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Force field",
        icon: spellIcons.force_field,
      },
      {
        name: "Energy Shield",
        icon: spellIcons.ENERGYSHIELD,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_HEAD_CLOTH_SET2: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Force Field",
        icon: spellIcons.force_field,
      },
      {
        name: "Ice Block",
        icon: spellIcons.Ice_block,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_HEAD_CLOTH_SET3: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Force Field",
        icon: spellIcons.force_field,
      },
      {
        name: "Firebreath",
        icon: spellIcons.Firebreath,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_HEAD_CLOTH_ROYAL: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Force Field",
        icon: spellIcons.force_field,
      },
      {
        name: "Perpetual Energy",
        icon: spellIcons.Perpetual_energy,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_HEAD_CLOTH_KEEPER: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Force Field",
        icon: spellIcons.force_field,
      },
      {
        name: "Perpetual Energy",
        icon: spellIcons.Perpetual_energy,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_HEAD_CLOTH_HELL: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Force Field",
        icon: spellIcons.force_field,
      },
      {
        name: "Purge",
        icon: spellIcons.Purge,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_HEAD_CLOTH_MORGANA: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Force Field",
        icon: spellIcons.force_field,
      },
      {
        name: "Inner Corruption",
        icon: spellIcons.Inner_Corruption,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_HEAD_CLOTH_FEY: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Force Field",
        icon: spellIcons.force_field,
      },
      {
        name: "Hyper Focus",
        icon: spellIcons.Hyper_Focus,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_HEAD_CLOTH_AVALON: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Force Field",
        icon: spellIcons.force_field,
      },
      {
        name: "Avalonian Beam",
        icon: spellIcons.Avalonian_beam,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_HEAD_LEATHER_SET1: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Self Cleanse",
        icon: spellIcons.SELF_CLEANSE,
      },
      {
        name: "Howl",
        icon: spellIcons.Howl,
      },
    ],
    passive1: [
      { name: "Balanced Mind", icon: spellIcons.Balanced_Mind },
      {
        name: "Swiftness",
        icon: spellIcons.Swiftness,
      },
      {
        name: "Quick Thinker",
        icon: spellIcons.Quick_thinker,
      },
    ],
  },
  T8_HEAD_LEATHER_SET2: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Self Cleanse",
        icon: spellIcons.SELF_CLEANSE,
      },
      {
        name: "Retaliate",
        icon: spellIcons.Retaliate,
      },
    ],
    passive1: [
      { name: "Balanced Mind", icon: spellIcons.Balanced_Mind },
      {
        name: "Swiftness",
        icon: spellIcons.Swiftness,
      },
      {
        name: "Quick Thinker",
        icon: spellIcons.Quick_thinker,
      },
    ],
  },
  T8_HEAD_LEATHER_SET3: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Self Cleanse",
        icon: spellIcons.SELF_CLEANSE,
      },
      {
        name: "Growing Rage",
        icon: spellIcons.Growing_rage,
      },
    ],
    passive1: [
      { name: "Balanced Mind", icon: spellIcons.Balanced_Mind },
      {
        name: "Swiftness",
        icon: spellIcons.Swiftness,
      },
      {
        name: "Quick Thinker",
        icon: spellIcons.Quick_thinker,
      },
    ],
  },
  T8_HEAD_LEATHER_ROYAL: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Self Cleanse",
        icon: spellIcons.SELF_CLEANSE,
      },
      {
        name: "Growing Rage",
        icon: spellIcons.Growing_rage,
      },
    ],
    passive1: [
      { name: "Balanced Mind", icon: spellIcons.Balanced_Mind },
      {
        name: "Swiftness",
        icon: spellIcons.Swiftness,
      },
      {
        name: "Quick Thinker",
        icon: spellIcons.Quick_thinker,
      },
    ],
  },
  T8_HEAD_LEATHER_MORGANA: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Self Cleanse",
        icon: spellIcons.SELF_CLEANSE,
      },
      {
        name: "Mortal Agony",
        icon: spellIcons.mortal_agony,
      },
    ],
    passive1: [
      { name: "Balanced Mind", icon: spellIcons.Balanced_Mind },
      {
        name: "Swiftness",
        icon: spellIcons.Swiftness,
      },
      {
        name: "Quick Thinker",
        icon: spellIcons.Quick_thinker,
      },
    ],
  },
  T8_HEAD_LEATHER_HELL: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Self Cleanse",
        icon: spellIcons.SELF_CLEANSE,
      },
      {
        name: "Smokebomb",
        icon: spellIcons.smokebomb,
      },
    ],
    passive1: [
      { name: "Balanced Mind", icon: spellIcons.Balanced_Mind },
      {
        name: "Swiftness",
        icon: spellIcons.Swiftness,
      },
      {
        name: "Quick Thinker",
        icon: spellIcons.Quick_thinker,
      },
    ],
  },
  T8_HEAD_LEATHER_UNDEAD: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Self Cleanse",
        icon: spellIcons.SELF_CLEANSE,
      },
      {
        name: "Flash Of Insight",
        icon: spellIcons.flash_of_insight,
      },
    ],
    passive1: [
      { name: "Balanced Mind", icon: spellIcons.Balanced_Mind },
      {
        name: "Swiftness",
        icon: spellIcons.Swiftness,
      },
      {
        name: "Quick Thinker",
        icon: spellIcons.Quick_thinker,
      },
    ],
  },
  T8_HEAD_LEATHER_FEY: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Self Cleanse",
        icon: spellIcons.SELF_CLEANSE,
      },
      {
        name: "Immortal",
        icon: spellIcons.Immortal,
      },
    ],
    passive1: [
      { name: "Balanced Mind", icon: spellIcons.Balanced_Mind },
      {
        name: "Swiftness",
        icon: spellIcons.Swiftness,
      },
      {
        name: "Quick Thinker",
        icon: spellIcons.Quick_thinker,
      },
    ],
  },
  T8_HEAD_LEATHER_AVALON: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Self Cleanse",
        icon: spellIcons.SELF_CLEANSE,
      },
      {
        name: "Nasty Wounds",
        icon: spellIcons.nasty_wounds,
      },
    ],
    passive1: [
      { name: "Balanced Mind", icon: spellIcons.Balanced_Mind },
      {
        name: "Swiftness",
        icon: spellIcons.Swiftness,
      },
      {
        name: "Quick Thinker",
        icon: spellIcons.Quick_thinker,
      },
    ],
  },
  T8_HEAD_PLATE_SET1: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Stone Skin",
        icon: spellIcons.stone_skin,
      },
      {
        name: "Block",
        icon: spellIcons.block,
      },
    ],
    passive1: [
      { name: "Toughness", icon: spellIcons.toughness },
      {
        name: "Authority",
        icon: spellIcons.authority,
      },
      {
        name: "Tenacity",
        icon: spellIcons.tenacity,
      },
    ],
  },
  T8_HEAD_PLATE_SET2: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Stone Skin",
        icon: spellIcons.stone_skin,
      },
      {
        name: "Displacement Immunity",
        icon: spellIcons.displacement_immunity,
      },
    ],
    passive1: [
      { name: "Toughness", icon: spellIcons.toughness },
      {
        name: "Authority",
        icon: spellIcons.authority,
      },
      {
        name: "Tenacity",
        icon: spellIcons.tenacity,
      },
    ],
  },
  T8_HEAD_PLATE_SET3: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Stone Skin",
        icon: spellIcons.stone_skin,
      },
      {
        name: "Emergency Shield",
        icon: spellIcons.emergency_shield,
      },
    ],
    passive1: [
      { name: "Toughness", icon: spellIcons.toughness },
      {
        name: "Authority",
        icon: spellIcons.authority,
      },
      {
        name: "Tenacity",
        icon: spellIcons.tenacity,
      },
    ],
  },
  T8_HEAD_PLATE_ROYAL: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Stone Skin",
        icon: spellIcons.stone_skin,
      },
      {
        name: "Ballista Support Fire",
        icon: spellIcons.ballista_support_fire,
      },
    ],
    passive1: [
      { name: "Toughness", icon: spellIcons.toughness },
      {
        name: "Authority",
        icon: spellIcons.authority,
      },
      {
        name: "Tenacity",
        icon: spellIcons.tenacity,
      },
    ],
  },
  T8_HEAD_PLATE_UNDEAD: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Stone Skin",
        icon: spellIcons.stone_skin,
      },
      {
        name: "Sacrifice",
        icon: spellIcons.sacrifice,
      },
    ],
    passive1: [
      { name: "Toughness", icon: spellIcons.toughness },
      {
        name: "Authority",
        icon: spellIcons.authority,
      },
      {
        name: "Tenacity",
        icon: spellIcons.tenacity,
      },
    ],
  },
  T8_HEAD_PLATE_HELL: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Stone Skin",
        icon: spellIcons.stone_skin,
      },
      {
        name: "Weapon Silence",
        icon: spellIcons.WEAPON_SILENCE,
      },
    ],
    passive1: [
      { name: "Toughness", icon: spellIcons.toughness },
      {
        name: "Authority",
        icon: spellIcons.authority,
      },
      {
        name: "Tenacity",
        icon: spellIcons.tenacity,
      },
    ],
  },
  T8_HEAD_PLATE_KEEPER: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Stone Skin",
        icon: spellIcons.stone_skin,
      },
      {
        name: "Electric Discharge",
        icon: spellIcons.electric_discharge,
      },
    ],
    passive1: [
      { name: "Toughness", icon: spellIcons.toughness },
      {
        name: "Authority",
        icon: spellIcons.authority,
      },
      {
        name: "Tenacity",
        icon: spellIcons.tenacity,
      },
    ],
  },
  T8_HEAD_PLATE_FEY: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Stone Skin",
        icon: spellIcons.stone_skin,
      },
      {
        name: "Spiders Thread",
        icon: spellIcons.spiders_thread,
      },
    ],
    passive1: [
      { name: "Toughness", icon: spellIcons.toughness },
      {
        name: "Authority",
        icon: spellIcons.authority,
      },
      {
        name: "Tenacity",
        icon: spellIcons.tenacity,
      },
    ],
  },
  T8_HEAD_PLATE_AVALON: {
    active1: [
      {
        name: "Energizing Shield",
        icon: spellIcons.ENERGIZING_SHIELD,
      },
      {
        name: "Stone Skin",
        icon: spellIcons.stone_skin,
      },
      {
        name: "Purifying Smoke",
        icon: spellIcons.purifying_smoke,
      },
    ],
    passive1: [
      { name: "Toughness", icon: spellIcons.toughness },
      {
        name: "Authority",
        icon: spellIcons.authority,
      },
      {
        name: "Tenacity",
        icon: spellIcons.tenacity,
      },
    ],
  },
  T8_ARMOR_CLOTH_SET1: {
    active1: [
      {
        name: "Out Of Combat Heal",
        icon: spellIcons.OUTOFCOMBATHEAL,
      },
      {
        name: "Frost Shield",
        icon: spellIcons.Frost_Shield,
      },
      {
        name: "Speed Caster",
        icon: spellIcons.Speed_Caster,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_ARMOR_CLOTH_SET2: {
    active1: [
      {
        name: "Out Of Combat Heal",
        icon: spellIcons.OUTOFCOMBATHEAL,
      },
      {
        name: "Frost Shield",
        icon: spellIcons.Frost_Shield,
      },
      {
        name: "Everlasting Spirit",
        icon: spellIcons.Everlasting_Spirit,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_ARMOR_CLOTH_SET3: {
    active1: [
      {
        name: "Out Of Combat Heal",
        icon: spellIcons.OUTOFCOMBATHEAL,
      },
      {
        name: "Frost Shield",
        icon: spellIcons.Frost_Shield,
      },
      {
        name: "Purging Shield",
        icon: spellIcons.Purging_Shield,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_ARMOR_CLOTH_ROYAL: {
    active1: [
      {
        name: "Out Of Combat Heal",
        icon: spellIcons.OUTOFCOMBATHEAL,
      },
      {
        name: "Frost Shield",
        icon: spellIcons.Frost_Shield,
      },
      {
        name: "Magic Rune",
        icon: spellIcons.Magic_Rune,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_ARMOR_CLOTH_KEEPER: {
    active1: [
      {
        name: "Out Of Combat Heal",
        icon: spellIcons.OUTOFCOMBATHEAL,
      },
      {
        name: "Frost Shield",
        icon: spellIcons.Frost_Shield,
      },
      {
        name: "Obsessive Burst",
        icon: spellIcons.Obsessive_Burst,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_ARMOR_CLOTH_HELL: {
    active1: [
      {
        name: "Out Of Combat Heal",
        icon: spellIcons.OUTOFCOMBATHEAL,
      },
      {
        name: "Frost Shield",
        icon: spellIcons.Frost_Shield,
      },
      {
        name: "Fear Aura",
        icon: spellIcons.Fear_Aura,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_ARMOR_CLOTH_MORGANA: {
    active1: [
      {
        name: "Out Of Combat Heal",
        icon: spellIcons.OUTOFCOMBATHEAL,
      },
      {
        name: "Frost Shield",
        icon: spellIcons.Frost_Shield,
      },
      {
        name: "Levitate",
        icon: spellIcons.Levitate,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_ARMOR_CLOTH_FEY: {
    active1: [
      {
        name: "Out Of Combat Heal",
        icon: spellIcons.OUTOFCOMBATHEAL,
      },
      {
        name: "Frost Shield",
        icon: spellIcons.Frost_Shield,
      },
      {
        name: "Wild Magic",
        icon: spellIcons.Wild_Magic,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_ARMOR_CLOTH_AVALON: {
    active1: [
      {
        name: "Out Of Combat Heal",
        icon: spellIcons.OUTOFCOMBATHEAL,
      },
      {
        name: "Frost Shield",
        icon: spellIcons.Frost_Shield,
      },
      {
        name: "Energy Emission",
        icon: spellIcons.Energy_Emission,
      },
    ],
    passive1: [
      { name: "Aggression", icon: spellIcons.aggression },
      {
        name: "Concentration",
        icon: spellIcons.Concentration,
      },
      {
        name: "Efficiency",
        icon: spellIcons.Efficiency,
      },
    ],
  },
  T8_ARMOR_LEATHER_SET1: {
    active1: [
      {
        name: "Out Of Combat Heal",
        icon: spellIcons.OUTOFCOMBATHEAL,
      },
      {
        name: "Flameshield",
        icon: spellIcons.FLAMESHIELD,
      },
      {
        name: "Bloodlust",
        icon: spellIcons.Bloodlust,
      },
    ],
    passive1: [
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      {
        name: "Passive CD Reduction",
        icon: spellIcons.PASSIVE_CD_REDUCTION,
      },
    ],
  },
  T8_ARMOR_LEATHER_SET2: {
    active1: [
      {
        name: "Out Of Combat Heal",
        icon: spellIcons.OUTOFCOMBATHEAL,
      },
      {
        name: "Flameshield",
        icon: spellIcons.FLAMESHIELD,
      },
      {
        name: "Haste",
        icon: spellIcons.HASTE,
      },
    ],
    passive1: [
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      {
        name: "Passive CD Reduction",
        icon: spellIcons.PASSIVE_CD_REDUCTION,
      },
    ],
  },
  T8_ARMOR_LEATHER_SET3: {
    active1: [
      {
        name: "Outofcombatheal",
        icon: spellIcons.OUTOFCOMBATHEAL,
      },
      {
        name: "Flameshield",
        icon: spellIcons.FLAMESHIELD,
      },
      {
        name: "Ambush",
        icon: spellIcons.Ambush,
      },
    ],
    passive1: [
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      {
        name: "Passive CD Reduction",
        icon: spellIcons.PASSIVE_CD_REDUCTION,
      },
    ],
  },
  T8_ARMOR_LEATHER_ROYAL: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Flame Shield", icon: spellIcons.FLAMESHIELD },
      { name: "Royal Banner", icon: spellIcons.Royal_Banner },
    ],
    passive1: [
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_ARMOR_LEATHER_MORGANA: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Flame Shield", icon: spellIcons.FLAMESHIELD },
      { name: "Storm Shield", icon: spellIcons.STORMSHIELD },
    ],
    passive1: [
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_ARMOR_LEATHER_HELL: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Flame Shield", icon: spellIcons.FLAMESHIELD },
      { name: "Life Steal Aura", icon: spellIcons.Life_Steal_Aura },
    ],
    passive1: [
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_ARMOR_LEATHER_UNDEAD: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Flame Shield", icon: spellIcons.FLAMESHIELD },
      { name: "Burn Aura", icon: spellIcons.BURNAURA },
    ],
    passive1: [
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_ARMOR_LEATHER_FEY: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Flame Shield", icon: spellIcons.FLAMESHIELD },
      { name: "Mist Walker", icon: spellIcons.MIST_WALKER },
    ],
    passive1: [
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_ARMOR_LEATHER_AVALON: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Flame Shield", icon: spellIcons.FLAMESHIELD },
      { name: "Dynamic Defense", icon: spellIcons.Dynamic_Defense },
    ],
    passive1: [
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },

  T8_ARMOR_PLATE_SET1: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Taunt", icon: spellIcons.Taunt },
      { name: "Enrage", icon: spellIcons.ENRAGE },
    ],
    passive1: [
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Cc Duration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
    passive2: [
      {
        name: "Passive Platearmor Health Reduction",
        icon: spellIcons.PASSIVE_PLATEARMOR_HEALTH_REDUCTION,
      },
      {
        name: "Passive Platearmor Threatgeneration",
        icon: spellIcons.PASSIVE_PLATEARMOR_THREATGENERATION,
      },
    ],
  },
  T8_ARMOR_PLATE_SET2: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Taunt", icon: spellIcons.Taunt },
      { name: "Wind Wall", icon: spellIcons.WINDWALL },
    ],
    passive1: [
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Cc Duration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
    passive2: [
      {
        name: "Passive Platearmor Health Reduction",
        icon: spellIcons.PASSIVE_PLATEARMOR_HEALTH_REDUCTION,
      },
      {
        name: "Passive Platearmor Threatgeneration",
        icon: spellIcons.PASSIVE_PLATEARMOR_THREATGENERATION,
      },
    ],
  },
  T8_ARMOR_PLATE_SET3: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Taunt", icon: spellIcons.Taunt },
      { name: "Enfeeble Aura", icon: spellIcons.ENFEEBLEAURA },
    ],
    passive1: [
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Cc Duration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
    passive2: [
      {
        name: "Passive Platearmor Health Reduction",
        icon: spellIcons.PASSIVE_PLATEARMOR_HEALTH_REDUCTION,
      },
      {
        name: "Passive Platearmor Threatgeneration",
        icon: spellIcons.PASSIVE_PLATEARMOR_THREATGENERATION,
      },
    ],
  },

  T8_ARMOR_PLATE_ROYAL: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Taunt", icon: spellIcons.Taunt },
      { name: "Mana Drain", icon: spellIcons.MANADRAIN },
    ],
    passive1: [
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Cc Duration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
    passive2: [
      {
        name: "Passive Platearmor Health Reduction",
        icon: spellIcons.PASSIVE_PLATEARMOR_HEALTH_REDUCTION,
      },
      {
        name: "Passive Platearmor Threatgeneration",
        icon: spellIcons.PASSIVE_PLATEARMOR_THREATGENERATION,
      },
    ],
  },
  T8_ARMOR_PLATE_UNDEAD: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Taunt", icon: spellIcons.Taunt },
      { name: "Armor Chain", icon: spellIcons.ARMORCHAIN },
    ],
    passive1: [
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Cc Duration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
    passive2: [
      {
        name: "Passive Platearmor Health Reduction",
        icon: spellIcons.PASSIVE_PLATEARMOR_HEALTH_REDUCTION,
      },
      {
        name: "Passive Platearmor Threatgeneration",
        icon: spellIcons.PASSIVE_PLATEARMOR_THREATGENERATION,
      },
    ],
  },
  T8_ARMOR_PLATE_HELL: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Taunt", icon: spellIcons.Taunt },
      { name: "Reflect Area", icon: spellIcons.REFLECTAREA },
    ],
    passive1: [
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Cc Duration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
    passive2: [
      {
        name: "Passive Platearmor Health Reduction",
        icon: spellIcons.PASSIVE_PLATEARMOR_HEALTH_REDUCTION,
      },
      {
        name: "Passive Platearmor Threatgeneration",
        icon: spellIcons.PASSIVE_PLATEARMOR_THREATGENERATION,
      },
    ],
  },
  T8_ARMOR_PLATE_KEEPER: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Taunt", icon: spellIcons.Taunt },
      { name: "Force Shield", icon: spellIcons.FORCESHIELD },
    ],
    passive1: [
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Cc Duration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
    passive2: [
      {
        name: "Passive Platearmor Health Reduction",
        icon: spellIcons.PASSIVE_PLATEARMOR_HEALTH_REDUCTION,
      },
      {
        name: "Passive Platearmor Threatgeneration",
        icon: spellIcons.PASSIVE_PLATEARMOR_THREATGENERATION,
      },
    ],
  },
  T8_ARMOR_PLATE_FEY: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Taunt", icon: spellIcons.Taunt },
      { name: "Armor Web", icon: spellIcons.ARMOR_WEB },
    ],
    passive1: [
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Cc Duration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
    passive2: [
      {
        name: "Passive Platearmor Health Reduction",
        icon: spellIcons.PASSIVE_PLATEARMOR_HEALTH_REDUCTION,
      },
      {
        name: "Passive Platearmor Threatgeneration",
        icon: spellIcons.PASSIVE_PLATEARMOR_THREATGENERATION,
      },
    ],
  },
  T8_ARMOR_PLATE_AVALON: {
    active1: [
      { name: "Out Of Combat Heal", icon: spellIcons.OUTOFCOMBATHEAL },
      { name: "Taunt", icon: spellIcons.Taunt },
      { name: "Reflect Channel", icon: spellIcons.REFLECT_CHANNEL },
    ],
    passive1: [
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Cc Duration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
    passive2: [
      {
        name: "Passive Platearmor Health Reduction",
        icon: spellIcons.PASSIVE_PLATEARMOR_HEALTH_REDUCTION,
      },
      {
        name: "Passive Platearmor Threatgeneration",
        icon: spellIcons.PASSIVE_PLATEARMOR_THREATGENERATION,
      },
    ],
  },
  T8_SHOES_CLOTH_SET1: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Eot", icon: spellIcons.SPRINTEOT },
      { name: "Channeled Run", icon: spellIcons.CHANNELED_RUN },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      {
        name: "Passive Increased Damage",
        icon: spellIcons.PASSIVE_INCREASED_DAMAGE,
      },
      { name: "Passive Castspeed", icon: spellIcons.PASSIVE_CASTSPEED },
      {
        name: "Passive Reduced Energycost",
        icon: spellIcons.PASSIVE_REDUCED_ENERGYCOST,
      },
    ],
  },
  T8_SHOES_CLOTH_SET2: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Eot", icon: spellIcons.SPRINTEOT },
      { name: "Blink", icon: spellIcons.BLINK },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      {
        name: "Passive Increased Damage",
        icon: spellIcons.PASSIVE_INCREASED_DAMAGE,
      },
      { name: "Passive Castspeed", icon: spellIcons.PASSIVE_CASTSPEED },
      {
        name: "Passive Reduced Energycost",
        icon: spellIcons.PASSIVE_REDUCED_ENERGYCOST,
      },
    ],
  },
  T8_SHOES_CLOTH_SET3: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Eot", icon: spellIcons.SPRINTEOT },
      { name: "Delayed Teleport", icon: spellIcons.DELAYED_TELEPORT },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      {
        name: "Passive Increased Damage",
        icon: spellIcons.PASSIVE_INCREASED_DAMAGE,
      },
      { name: "Passive Castspeed", icon: spellIcons.PASSIVE_CASTSPEED },
      {
        name: "Passive Reduced Energycost",
        icon: spellIcons.PASSIVE_REDUCED_ENERGYCOST,
      },
    ],
  },
  T8_SHOES_CLOTH_ROYAL: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Eot", icon: spellIcons.SPRINTEOT },
      { name: "Glass Movespeed", icon: spellIcons.GLASS_MOVESPEED },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      {
        name: "Passive Increased Damage",
        icon: spellIcons.PASSIVE_INCREASED_DAMAGE,
      },
      { name: "Passive Castspeed", icon: spellIcons.PASSIVE_CASTSPEED },
      {
        name: "Passive Reduced Energycost",
        icon: spellIcons.PASSIVE_REDUCED_ENERGYCOST,
      },
    ],
  },
  T8_SHOES_CLOTH_KEEPER: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Eot", icon: spellIcons.SPRINTEOT },
      { name: "Frostwalk", icon: spellIcons.FROSTWALK },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      {
        name: "Passive Increased Damage",
        icon: spellIcons.PASSIVE_INCREASED_DAMAGE,
      },
      { name: "Passive Castspeed", icon: spellIcons.PASSIVE_CASTSPEED },
      {
        name: "Passive Reduced Energycost",
        icon: spellIcons.PASSIVE_REDUCED_ENERGYCOST,
      },
    ],
  },
  T8_SHOES_CLOTH_HELL: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Eot", icon: spellIcons.SPRINTEOT },
      { name: "Swap", icon: spellIcons.SWAP },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      {
        name: "Passive Increased Damage",
        icon: spellIcons.PASSIVE_INCREASED_DAMAGE,
      },
      { name: "Passive Castspeed", icon: spellIcons.PASSIVE_CASTSPEED },
      {
        name: "Passive Reduced Energycost",
        icon: spellIcons.PASSIVE_REDUCED_ENERGYCOST,
      },
    ],
  },
  T8_SHOES_CLOTH_MORGANA: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Eot", icon: spellIcons.SPRINTEOT },
      { name: "Demonwalk", icon: spellIcons.DEMONWALK },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      {
        name: "Passive Increased Damage",
        icon: spellIcons.PASSIVE_INCREASED_DAMAGE,
      },
      { name: "Passive Castspeed", icon: spellIcons.PASSIVE_CASTSPEED },
      {
        name: "Passive Reduced Energycost",
        icon: spellIcons.PASSIVE_REDUCED_ENERGYCOST,
      },
    ],
  },
  T8_SHOES_CLOTH_FEY: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Eot", icon: spellIcons.SPRINTEOT },
      { name: "Translucent", icon: spellIcons.TRANSLUCENT },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      {
        name: "Passive Increased Damage",
        icon: spellIcons.PASSIVE_INCREASED_DAMAGE,
      },
      { name: "Passive Castspeed", icon: spellIcons.PASSIVE_CASTSPEED },
      {
        name: "Passive Reduced Energycost",
        icon: spellIcons.PASSIVE_REDUCED_ENERGYCOST,
      },
    ],
  },
  T8_SHOES_CLOTH_AVALON: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Eot", icon: spellIcons.SPRINTEOT },
      { name: "Hover Sprint", icon: spellIcons.HOVER_SPRINT },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      {
        name: "Passive Increased Damage",
        icon: spellIcons.PASSIVE_INCREASED_DAMAGE,
      },
      { name: "Passive Castspeed", icon: spellIcons.PASSIVE_CASTSPEED },
      {
        name: "Passive Reduced Energycost",
        icon: spellIcons.PASSIVE_REDUCED_ENERGYCOST,
      },
    ],
  },
  T8_SHOES_LEATHER_SET1: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Cd Reduction", icon: spellIcons.SPRINT_CD_REDUCTION },
      { name: "Cleanse Dash", icon: spellIcons.CLEANSE_DASH },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_SHOES_LEATHER_SET2: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Cd Reduction", icon: spellIcons.SPRINT_CD_REDUCTION },
      { name: "Oversprint", icon: spellIcons.OVERSPRINT },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },

  T8_SHOES_LEATHER_SET3: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Cd Reduction", icon: spellIcons.SPRINT_CD_REDUCTION },
      { name: "Assassin Dash", icon: spellIcons.ASSASSIN_DASH },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_SHOES_LEATHER_ROYAL: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Cd Reduction", icon: spellIcons.SPRINT_CD_REDUCTION },
      { name: "Jump", icon: spellIcons.JUMP },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_SHOES_LEATHER_MORGANA: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Cd Reduction", icon: spellIcons.SPRINT_CD_REDUCTION },
      { name: "Dmg Blink", icon: spellIcons.DMG_BLINK },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_SHOES_LEATHER_HELL: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Cd Reduction", icon: spellIcons.SPRINT_CD_REDUCTION },
      { name: "Deathmark", icon: spellIcons.DEATHMARK },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_SHOES_LEATHER_UNDEAD: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Cd Reduction", icon: spellIcons.SPRINT_CD_REDUCTION },
      { name: "Invisible Walk", icon: spellIcons.INVISIBLE_WALK },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_SHOES_LEATHER_FEY: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Cd Reduction", icon: spellIcons.SPRINT_CD_REDUCTION },
      { name: "After Image", icon: spellIcons.AFTER_IMAGE },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_SHOES_LEATHER_AVALON: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Sprint Cd Reduction", icon: spellIcons.SPRINT_CD_REDUCTION },
      { name: "Blindspot", icon: spellIcons.BLINDSPOT },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Balance", icon: spellIcons.PASSIVE_BALANCE },
      {
        name: "Passive Increased Aaspeed",
        icon: spellIcons.PASSIVE_INCREASED_AASPEED,
      },
      { name: "Passive Cd Reduction", icon: spellIcons.PASSIVE_CD_REDUCTION },
    ],
  },
  T8_SHOES_PLATE_SET1: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Rejuvenating Sprint", icon: spellIcons.Rejuvenating_Sprint },
      { name: "Wanderlust", icon: spellIcons.WANDERLUST },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Ccduration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
  },
  T8_SHOES_PLATE_SET2: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Rejuvenating Sprint", icon: spellIcons.Rejuvenating_Sprint },
      { name: "Charge Shield", icon: spellIcons.CHARGE_SHIELD },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Ccduration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
  },
  T8_SHOES_PLATE_SET3: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Rejuvenating Sprint", icon: spellIcons.Rejuvenating_Sprint },
      { name: "Max Health Buff", icon: spellIcons.MAXHEALTHBUFF },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Ccduration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
  },
  T8_SHOES_PLATE_ROYAL: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Rejuvenating Sprint", icon: spellIcons.Rejuvenating_Sprint },
      { name: "Royal March", icon: spellIcons.ROYAL_MARCH },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Ccduration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
  },
  T8_SHOES_PLATE_UNDEAD: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Rejuvenating Sprint", icon: spellIcons.Rejuvenating_Sprint },
      { name: "Battle Frenzy", icon: spellIcons.BATTLEFRENZY },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Ccduration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
  },
  T8_SHOES_PLATE_HELL: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Rejuvenating Sprint", icon: spellIcons.Rejuvenating_Sprint },
      { name: "Berserk Sprint", icon: spellIcons.BERSERK_SPRINT },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Ccduration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
  },
  T8_SHOES_PLATE_KEEPER: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Rejuvenating Sprint", icon: spellIcons.Rejuvenating_Sprint },
      { name: "Shoulder Tackle", icon: spellIcons.SHOULDERTACKLE },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Ccduration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
  },
  T8_SHOES_PLATE_FEY: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Rejuvenating Sprint", icon: spellIcons.Rejuvenating_Sprint },
      { name: "Charge In", icon: spellIcons.CHARGE_IN },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Ccduration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
  },
  T8_SHOES_PLATE_AVALON: {
    active1: [
      { name: "Dodge", icon: spellIcons.DODGE },
      { name: "Rejuvenating Sprint", icon: spellIcons.Rejuvenating_Sprint },
      { name: "Cc Block", icon: spellIcons.CC_BLOCK },
    ],
    passive1: [
      { name: "Passive Maxload Shoes", icon: spellIcons.PASSIVE_MAXLOAD_SHOES },
      { name: "Passive Mr Ar", icon: spellIcons.PASSIVE_MR_AR },
      { name: "Passive Ccduration", icon: spellIcons.PASSIVE_CCDURATION },
      { name: "Passive Increased Ccr", icon: spellIcons.PASSIVE_INCREASED_CCR },
    ],
  },
  T8_MAIN_FIRESTAFF: {
    active1: [
      { name: "Fire Bolt", icon: spellIcons.Fire_Bolt },
      { name: "Burning Field", icon: spellIcons.BurningField },
      { name: "Searing Flame", icon: spellIcons.SearingFlame },
    ],
    active2: [
      { name: "Flame Blast", icon: spellIcons.FlameBlast },
      { name: "Wall Of Flames", icon: spellIcons.WallofFlames },
      { name: "Raging Flare", icon: spellIcons.RagingFlare },
      { name: "Fire Wave", icon: spellIcons.FireWave },
      { name: "Fire Artillery", icon: spellIcons.FireArtillery },
    ],
    active3: [{ name: "Pyroblast", icon: spellIcons.Pyroblast }],
    passive1: [
      { name: "Passive Burn", icon: spellIcons.PASSIVE_BURN },
      {
        name: "Passive Energychance Firestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FIRESTAFF,
      },
      {
        name: "Passive Castingspeed Chance Firestaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FIRESTAFF,
      },
      {
        name: "Passive Spellpower Caster Firestaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FIRESTAFF,
      },
    ],
  },

  T8_2H_FIRESTAFF: {
    active1: [
      { name: "Fire Bolt", icon: spellIcons.Fire_Bolt },
      { name: "Burning Field", icon: spellIcons.BurningField },
      { name: "Searing Flame", icon: spellIcons.SearingFlame },
    ],
    active2: [
      { name: "Flame Blast", icon: spellIcons.FlameBlast },
      { name: "Wall Of Flames", icon: spellIcons.WallofFlames },
      { name: "Raging Flare", icon: spellIcons.RagingFlare },
      { name: "Fire Wave", icon: spellIcons.FireWave },
      { name: "Fire Artillery", icon: spellIcons.FireArtillery },
    ],
    active3: [{ name: "Flame Pillar", icon: spellIcons.FLAMEPILLAR }],
    passive1: [
      { name: "Passive Burn", icon: spellIcons.PASSIVE_BURN },
      {
        name: "Passive Energychance Firestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FIRESTAFF,
      },
      {
        name: "Passive Castingspeed Chance Firestaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FIRESTAFF,
      },
      {
        name: "Passive Spellpower Caster Firestaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FIRESTAFF,
      },
    ],
  },

  T8_2H_INFERNOSTAFF: {
    active1: [
      { name: "Fire Bolt", icon: spellIcons.Fire_Bolt },
      { name: "Burning Field", icon: spellIcons.BurningField },
      { name: "Searing Flame", icon: spellIcons.SearingFlame },
    ],
    active2: [
      { name: "Flame Blast", icon: spellIcons.FlameBlast },
      { name: "Wall Of Flames", icon: spellIcons.WallofFlames },
      { name: "Raging Flare", icon: spellIcons.RagingFlare },
      { name: "Fire Wave", icon: spellIcons.FireWave },
      { name: "Fire Artillery", icon: spellIcons.FireArtillery },
    ],
    active3: [{ name: "Human Torch", icon: spellIcons.HUMAN_TORCH }],
    passive1: [
      { name: "Passive Burn", icon: spellIcons.PASSIVE_BURN },
      {
        name: "Passive Energychance Firestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FIRESTAFF,
      },
      {
        name: "Passive Castingspeed Chance Firestaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FIRESTAFF,
      },
      {
        name: "Passive Spellpower Caster Firestaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FIRESTAFF,
      },
    ],
  },

  T8_MAIN_FIRESTAFF_KEEPER: {
    active1: [
      { name: "Fire Bolt", icon: spellIcons.Fire_Bolt },
      { name: "Burning Field", icon: spellIcons.BurningField },
      { name: "Searing Flame", icon: spellIcons.SearingFlame },
    ],
    active2: [
      { name: "Flame Blast", icon: spellIcons.FlameBlast },
      { name: "Wall Of Flames", icon: spellIcons.WallofFlames },
      { name: "Raging Flare", icon: spellIcons.RagingFlare },
      { name: "Fire Wave", icon: spellIcons.FireWave },
      { name: "Fire Artillery", icon: spellIcons.FireArtillery },
    ],
    active3: [{ name: "Magmasphere", icon: spellIcons.MAGMASPHERE }],
    passive1: [
      { name: "Passive Burn", icon: spellIcons.PASSIVE_BURN },
      {
        name: "Passive Energychance Firestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FIRESTAFF,
      },
      {
        name: "Passive Castingspeed Chance Firestaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FIRESTAFF,
      },
      {
        name: "Passive Spellpower Caster Firestaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FIRESTAFF,
      },
    ],
  },

  T8_2H_FIRESTAFF_HELL: {
    active1: [
      { name: "Fire Bolt", icon: spellIcons.Fire_Bolt },
      { name: "Burning Field", icon: spellIcons.BurningField },
      { name: "Searing Flame", icon: spellIcons.SearingFlame },
    ],
    active2: [
      { name: "Flame Blast", icon: spellIcons.FlameBlast },
      { name: "Wall Of Flames", icon: spellIcons.WallofFlames },
      { name: "Raging Flare", icon: spellIcons.RagingFlare },
      { name: "Fire Wave", icon: spellIcons.FireWave },
      { name: "Fire Artillery", icon: spellIcons.FireArtillery },
    ],
    active3: [{ name: "Meteor", icon: spellIcons.METEOR }],
    passive1: [
      { name: "Passive Burn", icon: spellIcons.PASSIVE_BURN },
      {
        name: "Passive Energychance Firestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FIRESTAFF,
      },
      {
        name: "Passive Castingspeed Chance Firestaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FIRESTAFF,
      },
      {
        name: "Passive Spellpower Caster Firestaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FIRESTAFF,
      },
    ],
  },

  T8_2H_INFERNOSTAFF_MORGANA: {
    active1: [
      { name: "Fire Bolt", icon: spellIcons.Fire_Bolt },
      { name: "Burning Field", icon: spellIcons.BurningField },
      { name: "Searing Flame", icon: spellIcons.SearingFlame },
    ],
    active2: [
      { name: "Flame Blast", icon: spellIcons.FlameBlast },
      { name: "Wall Of Flames", icon: spellIcons.WallofFlames },
      { name: "Raging Flare", icon: spellIcons.RagingFlare },
      { name: "Fire Wave", icon: spellIcons.FireWave },
      { name: "Fire Artillery", icon: spellIcons.FireArtillery },
    ],
    active3: [{ name: "Flame Tornado", icon: spellIcons.FLAMETORNADO }],
    passive1: [
      { name: "Passive Burn", icon: spellIcons.PASSIVE_BURN },
      {
        name: "Passive Energychance Firestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FIRESTAFF,
      },
      {
        name: "Passive Castingspeed Chance Firestaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FIRESTAFF,
      },
      {
        name: "Passive Spellpower Caster Firestaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FIRESTAFF,
      },
    ],
  },
  T8_2H_FIRE_RINGPAIR_AVALON: {
    active1: [
      { name: "Fire Bolt", icon: spellIcons.Fire_Bolt },
      { name: "Burning Field", icon: spellIcons.BurningField },
      { name: "Searing Flame", icon: spellIcons.SearingFlame },
    ],
    active2: [
      { name: "Flame Blast", icon: spellIcons.FlameBlast },
      { name: "Wall Of Flames", icon: spellIcons.WallofFlames },
      { name: "Raging Flare", icon: spellIcons.RagingFlare },
      { name: "Fire Wave", icon: spellIcons.FireWave },
      { name: "Fire Artillery", icon: spellIcons.FireArtillery },
    ],
    active3: [{ name: "Firephoenix", icon: spellIcons.FIREPHOENIX }],
    passive1: [
      { name: "Passive Burn", icon: spellIcons.PASSIVE_BURN },
      {
        name: "Passive Energychance Firestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FIRESTAFF,
      },
      {
        name: "Passive Castingspeed Chance Firestaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FIRESTAFF,
      },
      {
        name: "Passive Spellpower Caster Firestaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FIRESTAFF,
      },
    ],
  },

  T8_MAIN_FIRESTAFF_CRYSTAL: {
    active1: [
      { name: "Fire Bolt", icon: spellIcons.Fire_Bolt },
      { name: "Burning Field", icon: spellIcons.BurningField },
      { name: "Searing Flame", icon: spellIcons.SearingFlame },
    ],
    active2: [
      { name: "Flame Blast", icon: spellIcons.FlameBlast },
      { name: "Wall Of Flames", icon: spellIcons.WallofFlames },
      { name: "Raging Flare", icon: spellIcons.RagingFlare },
      { name: "Fire Wave", icon: spellIcons.FireWave },
      { name: "Fire Artillery", icon: spellIcons.FireArtillery },
    ],
    active3: [{ name: "Flamedash", icon: spellIcons.FLAMEDASH }],
    passive1: [
      { name: "Passive Burn", icon: spellIcons.PASSIVE_BURN },
      {
        name: "Passive Energychance Firestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FIRESTAFF,
      },
      {
        name: "Passive Castingspeed Chance Firestaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FIRESTAFF,
      },
      {
        name: "Passive Spellpower Caster Firestaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FIRESTAFF,
      },
    ],
  },

  T8_MAIN_HOLYSTAFF: {
    active1: [
      { name: "Generous Heal", icon: spellIcons.GENEROUSHEAL },
      { name: "Smite AOE", icon: spellIcons.SMITE_AOE },
      { name: "Holy Flash", icon: spellIcons.HOLYFLASH },
    ],
    active2: [
      { name: "Pulsing Heal", icon: spellIcons.PULSINGHEAL },
      { name: "Healing Beam", icon: spellIcons.HEALINGBEAM },
      { name: "Holy HOT", icon: spellIcons.HOLYHOT },
      { name: "Holy Orb", icon: spellIcons.HOLYORB },
      { name: "Resurrection", icon: spellIcons.RESURRECTION },
    ],
    active3: [
      {
        name: "Holy Desperate Prayer 2",
        icon: spellIcons.HOLYDESPERATEPRAYER2,
      },
    ],
    passive1: [
      {
        name: "Passive Healpowerchance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energychance Holystaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HOLYSTAFF,
      },
      {
        name: "Passive Knockback Caster Holystaff",
        icon: spellIcons.PASSIVE_KNOCKBACK_CASTER_HOLYSTAFF,
      },
      { name: "Passive Holy Ascended", icon: spellIcons.PASSIVE_HOLY_ASCENDED },
    ],
  },

  T8_2H_HOLYSTAFF: {
    active1: [
      { name: "Generous Heal", icon: spellIcons.GENEROUSHEAL },
      { name: "Smite AOE", icon: spellIcons.SMITE_AOE },
      { name: "Holy Flash", icon: spellIcons.HOLYFLASH },
    ],
    active2: [
      { name: "Pulsing Heal", icon: spellIcons.PULSINGHEAL },
      { name: "Healing Beam", icon: spellIcons.HEALINGBEAM },
      { name: "Holy HOT", icon: spellIcons.HOLYHOT },
      { name: "Holy Orb", icon: spellIcons.HOLYORB },
      { name: "Resurrection", icon: spellIcons.RESURRECTION },
    ],
    active3: [{ name: "Holy Explosion", icon: spellIcons.HOLYEXPLOSION }],
    passive1: [
      {
        name: "Passive Healpowerchance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energychance Holystaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HOLYSTAFF,
      },
      {
        name: "Passive Knockback Caster Holystaff",
        icon: spellIcons.PASSIVE_KNOCKBACK_CASTER_HOLYSTAFF,
      },
      { name: "Passive Holy Ascended", icon: spellIcons.PASSIVE_HOLY_ASCENDED },
    ],
  },

  T8_2H_DIVINESTAFF: {
    active1: [
      { name: "Generous Heal", icon: spellIcons.GENEROUSHEAL },
      { name: "Smite AOE", icon: spellIcons.SMITE_AOE },
      { name: "Holy Flash", icon: spellIcons.HOLYFLASH },
    ],
    active2: [
      { name: "Pulsing Heal", icon: spellIcons.PULSINGHEAL },
      { name: "Healing Beam", icon: spellIcons.HEALINGBEAM },
      { name: "Holy HOT", icon: spellIcons.HOLYHOT },
      { name: "Holy Orb", icon: spellIcons.HOLYORB },
      { name: "Resurrection", icon: spellIcons.RESURRECTION },
    ],
    active3: [{ name: "Holy Shield", icon: spellIcons.HOLYSHIELD }],
    passive1: [
      {
        name: "Passive Healpowerchance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energychance Holystaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HOLYSTAFF,
      },
      {
        name: "Passive Knockback Caster Holystaff",
        icon: spellIcons.PASSIVE_KNOCKBACK_CASTER_HOLYSTAFF,
      },
      { name: "Passive Holy Ascended", icon: spellIcons.PASSIVE_HOLY_ASCENDED },
    ],
  },
  T8_MAIN_HOLYSTAFF_MORGANA: {
    active1: [
      { name: "Generous Heal", icon: spellIcons.GENEROUSHEAL },
      { name: "Smite (AoE)", icon: spellIcons.SMITE_AOE },
      { name: "Holy Flash", icon: spellIcons.HOLYFLASH },
    ],
    active2: [
      { name: "Pulsing Heal", icon: spellIcons.PULSINGHEAL },
      { name: "Healing Beam", icon: spellIcons.HEALINGBEAM },
      { name: "Holy Hot", icon: spellIcons.HOLYHOT },
      { name: "Holy Orb", icon: spellIcons.HOLYORB },
      { name: "Resurrection", icon: spellIcons.RESURRECTION },
    ],
    active3: [{ name: "Holy Touch", icon: spellIcons.HOLYTOUCH }],
    passive1: [
      {
        name: "Passive Heal Power Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energy Chance Holystaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HOLYSTAFF,
      },
      {
        name: "Passive Knockback Caster Holystaff",
        icon: spellIcons.PASSIVE_KNOCKBACK_CASTER_HOLYSTAFF,
      },
      { name: "Passive Holy Ascended", icon: spellIcons.PASSIVE_HOLY_ASCENDED },
    ],
  },
  T8_2H_HOLYSTAFF_HELL: {
    active1: [
      { name: "Generous Heal", icon: spellIcons.GENEROUSHEAL },
      { name: "Smite (AoE)", icon: spellIcons.SMITE_AOE },
      { name: "Holy Flash", icon: spellIcons.HOLYFLASH },
    ],
    active2: [
      { name: "Pulsing Heal", icon: spellIcons.PULSINGHEAL },
      { name: "Healing Beam", icon: spellIcons.HEALINGBEAM },
      { name: "Holy Hot", icon: spellIcons.HOLYHOT },
      { name: "Holy Orb", icon: spellIcons.HOLYORB },
      { name: "Resurrection", icon: spellIcons.RESURRECTION },
    ],
    active3: [{ name: "Holy Ultimate", icon: spellIcons.HOLY_ULTIMATE }],
    passive1: [
      {
        name: "Passive Heal Power Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energy Chance Holystaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HOLYSTAFF,
      },
      {
        name: "Passive Knockback Caster Holystaff",
        icon: spellIcons.PASSIVE_KNOCKBACK_CASTER_HOLYSTAFF,
      },
      { name: "Passive Holy Ascended", icon: spellIcons.PASSIVE_HOLY_ASCENDED },
    ],
  },
  T8_2H_HOLYSTAFF_UNDEAD: {
    active1: [
      { name: "Generous Heal", icon: spellIcons.GENEROUSHEAL },
      { name: "Smite (AoE)", icon: spellIcons.SMITE_AOE },
      { name: "Holy Flash", icon: spellIcons.HOLYFLASH },
    ],
    active2: [
      { name: "Pulsing Heal", icon: spellIcons.PULSINGHEAL },
      { name: "Healing Beam", icon: spellIcons.HEALINGBEAM },
      { name: "Holy Hot", icon: spellIcons.HOLYHOT },
      { name: "Holy Orb", icon: spellIcons.HOLYORB },
      { name: "Resurrection", icon: spellIcons.RESURRECTION },
    ],
    active3: [{ name: "Celestial Sphere", icon: spellIcons.CELESTIAL_SPHERE }],
    passive1: [
      {
        name: "Passive Heal Power Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energy Chance Holystaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HOLYSTAFF,
      },
      {
        name: "Passive Knockback Caster Holystaff",
        icon: spellIcons.PASSIVE_KNOCKBACK_CASTER_HOLYSTAFF,
      },
      { name: "Passive Holy Ascended", icon: spellIcons.PASSIVE_HOLY_ASCENDED },
    ],
  },
  T8_MAIN_HOLYSTAFF_AVALON: {
    active1: [
      { name: "Generous Heal", icon: spellIcons.GENEROUSHEAL },
      { name: "Smite (AoE)", icon: spellIcons.SMITE_AOE },
      { name: "Holy Flash", icon: spellIcons.HOLYFLASH },
    ],
    active2: [
      { name: "Pulsing Heal", icon: spellIcons.PULSINGHEAL },
      { name: "Healing Beam", icon: spellIcons.HEALINGBEAM },
      { name: "Holy Hot", icon: spellIcons.HOLYHOT },
      { name: "Holy Orb", icon: spellIcons.HOLYORB },
      { name: "Resurrection", icon: spellIcons.RESURRECTION },
    ],
    active3: [{ name: "Divine Jump", icon: spellIcons.DIVINE_JUMP }],
    passive1: [
      {
        name: "Passive Heal Power Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energy Chance Holystaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HOLYSTAFF,
      },
      {
        name: "Passive Knockback Caster Holystaff",
        icon: spellIcons.PASSIVE_KNOCKBACK_CASTER_HOLYSTAFF,
      },
      { name: "Passive Holy Ascended", icon: spellIcons.PASSIVE_HOLY_ASCENDED },
    ],
  },
  T8_2H_HOLYSTAFF_CRYSTAL: {
    active1: [
      { name: "Generous Heal", icon: spellIcons.GENEROUSHEAL },
      { name: "Smite (AoE)", icon: spellIcons.SMITE_AOE },
      { name: "Holy Flash", icon: spellIcons.HOLYFLASH },
    ],
    active2: [
      { name: "Pulsing Heal", icon: spellIcons.PULSINGHEAL },
      { name: "Healing Beam", icon: spellIcons.HEALINGBEAM },
      { name: "Holy Hot", icon: spellIcons.HOLYHOT },
      { name: "Holy Orb", icon: spellIcons.HOLYORB },
      { name: "Resurrection", icon: spellIcons.RESURRECTION },
    ],
    active3: [{ name: "Holy Dispel", icon: spellIcons.HOLY_DISPEL }],
    passive1: [
      {
        name: "Passive Heal Power Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energy Chance Holystaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HOLYSTAFF,
      },
      {
        name: "Passive Knockback Caster Holystaff",
        icon: spellIcons.PASSIVE_KNOCKBACK_CASTER_HOLYSTAFF,
      },
      { name: "Passive Holy Ascended", icon: spellIcons.PASSIVE_HOLY_ASCENDED },
    ],
  },
  T8_MAIN_ARCANESTAFF: {
    active1: [
      { name: "Arcane Chain Missile", icon: spellIcons.ARCANE_CHAIN_MISSILE },
      { name: "Shield Friendly", icon: spellIcons.SHIELDFRIENDLY },
      { name: "Magic Shock", icon: spellIcons.MAGICSHOCK },
    ],
    active2: [
      { name: "Enigma Blade", icon: spellIcons.ENIGMA_BLADE },
      { name: "Cleanse Speed", icon: spellIcons.CLEANSESPEED2 },
      { name: "Frazzle", icon: spellIcons.FRAZZLE2 },
      { name: "Empower Beam", icon: spellIcons.EMPOWERBEAM },
      { name: "Mimic", icon: spellIcons.MIMIC },
    ],
    active3: [{ name: "Arcane Orb", icon: spellIcons.ARCANEORB2 }],
    passive1: [
      {
        name: "Passive Attack Buff Arcanestaff",
        icon: spellIcons.PASSIVE_ATTACKBUFF_ARCANESTAFF,
      },
      {
        name: "Passive Energy Chance Arcanestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_ARCANESTAFF,
      },
      {
        name: "Passive Armor Caster Arcanestaff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_ARCANESTAFF,
      },
      {
        name: "Passive Silence Chance",
        icon: spellIcons.PASSIVE_SILENCECHANCE,
      },
    ],
  },
  T8_2H_ARCANESTAFF: {
    active1: [
      { name: "Arcane Chain Missile", icon: spellIcons.ARCANE_CHAIN_MISSILE },
      { name: "Shield Friendly", icon: spellIcons.SHIELDFRIENDLY },
      { name: "Magic Shock", icon: spellIcons.MAGICSHOCK },
    ],
    active2: [
      { name: "Enigma Blade", icon: spellIcons.ENIGMA_BLADE },
      { name: "Cleanse Speed", icon: spellIcons.CLEANSESPEED2 },
      { name: "Frazzle", icon: spellIcons.FRAZZLE2 },
      { name: "Empower Beam", icon: spellIcons.EMPOWERBEAM },
      { name: "Mimic", icon: spellIcons.MIMIC },
    ],
    active3: [{ name: "Time Freeze", icon: spellIcons.TIME_FREEZE }],
    passive1: [
      {
        name: "Passive Attack Buff Arcanestaff",
        icon: spellIcons.PASSIVE_ATTACKBUFF_ARCANESTAFF,
      },
      {
        name: "Passive Energy Chance Arcanestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_ARCANESTAFF,
      },
      {
        name: "Passive Armor Caster Arcanestaff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_ARCANESTAFF,
      },
      {
        name: "Passive Silence Chance",
        icon: spellIcons.PASSIVE_SILENCECHANCE,
      },
    ],
  },
  T8_2H_ENIGMATICSTAFF: {
    active1: [
      { name: "Arcane Chain Missile", icon: spellIcons.ARCANE_CHAIN_MISSILE },
      { name: "Shield Friendly", icon: spellIcons.SHIELDFRIENDLY },
      { name: "Magic Shock", icon: spellIcons.MAGICSHOCK },
    ],
    active2: [
      { name: "Enigma Blade", icon: spellIcons.ENIGMA_BLADE },
      { name: "Cleanse Speed", icon: spellIcons.CLEANSESPEED2 },
      { name: "Frazzle", icon: spellIcons.FRAZZLE2 },
      { name: "Empower Beam", icon: spellIcons.EMPOWERBEAM },
      { name: "Mimic", icon: spellIcons.MIMIC },
    ],
    active3: [{ name: "Invulnerability", icon: spellIcons.INVULNERABILITY }],
    passive1: [
      {
        name: "Passive Attack Buff Arcanestaff",
        icon: spellIcons.PASSIVE_ATTACKBUFF_ARCANESTAFF,
      },
      {
        name: "Passive Energy Chance Arcanestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_ARCANESTAFF,
      },
      {
        name: "Passive Armor Caster Arcanestaff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_ARCANESTAFF,
      },
      {
        name: "Passive Silence Chance",
        icon: spellIcons.PASSIVE_SILENCECHANCE,
      },
    ],
  },
  T8_MAIN_ARCANESTAFF_UNDEAD: {
    active1: [
      { name: "Arcane Chain Missile", icon: spellIcons.ARCANE_CHAIN_MISSILE },
      { name: "Shield Friendly", icon: spellIcons.SHIELDFRIENDLY },
      { name: "Magic Shock", icon: spellIcons.MAGICSHOCK },
    ],
    active2: [
      { name: "Enigma Blade", icon: spellIcons.ENIGMA_BLADE },
      { name: "Cleanse Speed", icon: spellIcons.CLEANSESPEED2 },
      { name: "Frazzle", icon: spellIcons.FRAZZLE2 },
      { name: "Empower Beam", icon: spellIcons.EMPOWERBEAM },
      { name: "Mimic", icon: spellIcons.MIMIC },
    ],
    active3: [{ name: "Black Hole", icon: spellIcons.BLACKHOLE }],
    passive1: [
      {
        name: "Passive Attack Buff Arcane Staff",
        icon: spellIcons.PASSIVE_ATTACKBUFF_ARCANESTAFF,
      },
      {
        name: "Passive Energy Chance Arcane Staff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_ARCANESTAFF,
      },
      {
        name: "Passive Armor Caster Arcane Staff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_ARCANESTAFF,
      },
      {
        name: "Passive Silence Chance",
        icon: spellIcons.PASSIVE_SILENCECHANCE,
      },
    ],
  },
  T8_2H_ARCANESTAFF_HELL: {
    active1: [
      { name: "Arcane Chain Missile", icon: spellIcons.ARCANE_CHAIN_MISSILE },
      { name: "Shield Friendly", icon: spellIcons.SHIELDFRIENDLY },
      { name: "Magic Shock", icon: spellIcons.MAGICSHOCK },
    ],
    active2: [
      { name: "Enigma Blade", icon: spellIcons.ENIGMA_BLADE },
      { name: "Cleanse Speed", icon: spellIcons.CLEANSESPEED2 },
      { name: "Frazzle", icon: spellIcons.FRAZZLE2 },
      { name: "Empower Beam", icon: spellIcons.EMPOWERBEAM },
      { name: "Mimic", icon: spellIcons.MIMIC },
    ],
    active3: [{ name: "Arcane Corridor", icon: spellIcons.ARCANECORRIDOR }],
    passive1: [
      {
        name: "Passive Attack Buff Arcane Staff",
        icon: spellIcons.PASSIVE_ATTACKBUFF_ARCANESTAFF,
      },
      {
        name: "Passive Energy Chance Arcane Staff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_ARCANESTAFF,
      },
      {
        name: "Passive Armor Caster Arcane Staff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_ARCANESTAFF,
      },
      {
        name: "Passive Silence Chance",
        icon: spellIcons.PASSIVE_SILENCECHANCE,
      },
    ],
  },
  T8_2H_ENIGMATICORB_MORGANA: {
    active1: [
      { name: "Arcane Chain Missile", icon: spellIcons.ARCANE_CHAIN_MISSILE },
      { name: "Shield Friendly", icon: spellIcons.SHIELDFRIENDLY },
      { name: "Magic Shock", icon: spellIcons.MAGICSHOCK },
    ],
    active2: [
      { name: "Enigma Blade", icon: spellIcons.ENIGMA_BLADE },
      { name: "Cleanse Speed", icon: spellIcons.CLEANSESPEED2 },
      { name: "Frazzle", icon: spellIcons.FRAZZLE2 },
      { name: "Empower Beam", icon: spellIcons.EMPOWERBEAM },
      { name: "Mimic", icon: spellIcons.MIMIC },
    ],
    active3: [{ name: "Void", icon: spellIcons.VOID }],
    passive1: [
      {
        name: "Passive Attack Buff Arcane Staff",
        icon: spellIcons.PASSIVE_ATTACKBUFF_ARCANESTAFF,
      },
      {
        name: "Passive Energy Chance Arcane Staff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_ARCANESTAFF,
      },
      {
        name: "Passive Armor Caster Arcane Staff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_ARCANESTAFF,
      },
      {
        name: "Passive Silence Chance",
        icon: spellIcons.PASSIVE_SILENCECHANCE,
      },
    ],
  },

  T8_2H_ARCANE_RINGPAIR_AVALON: {
    active1: [
      { name: "Arcane Chain Missile", icon: spellIcons.ARCANE_CHAIN_MISSILE },
      { name: "Shield Friendly", icon: spellIcons.SHIELDFRIENDLY },
      { name: "Magic Shock", icon: spellIcons.MAGICSHOCK },
    ],
    active2: [
      { name: "Enigma Blade", icon: spellIcons.ENIGMA_BLADE },
      { name: "Cleanse Speed", icon: spellIcons.CLEANSESPEED2 },
      { name: "Frazzle", icon: spellIcons.FRAZZLE2 },
      { name: "Empower Beam", icon: spellIcons.EMPOWERBEAM },
      { name: "Mimic", icon: spellIcons.MIMIC },
    ],
    active3: [{ name: "Arcane Meteor", icon: spellIcons.ARCANE_METEOR }],
    passive1: [
      {
        name: "Passive Attack Buff Arcane Staff",
        icon: spellIcons.PASSIVE_ATTACKBUFF_ARCANESTAFF,
      },
      {
        name: "Passive Energy Chance Arcane Staff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_ARCANESTAFF,
      },
      {
        name: "Passive Armor Caster Arcane Staff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_ARCANESTAFF,
      },
      {
        name: "Passive Silence Chance",
        icon: spellIcons.PASSIVE_SILENCECHANCE,
      },
    ],
  },
  T8_2H_ARCANESTAFF_CRYSTAL: {
    active1: [
      { name: "Arcane Chain Missile", icon: spellIcons.ARCANE_CHAIN_MISSILE },
      { name: "Shield Friendly", icon: spellIcons.SHIELDFRIENDLY },
      { name: "Magic Shock", icon: spellIcons.MAGICSHOCK },
    ],
    active2: [
      { name: "Enigma Blade", icon: spellIcons.ENIGMA_BLADE },
      { name: "Cleanse Speed", icon: spellIcons.CLEANSESPEED2 },
      { name: "Frazzle", icon: spellIcons.FRAZZLE2 },
      { name: "Empower Beam", icon: spellIcons.EMPOWERBEAM },
      { name: "Mimic", icon: spellIcons.MIMIC },
    ],
    active3: [{ name: "Starfall (DoT)", icon: spellIcons.STARFALL_DOT }],
    passive1: [
      {
        name: "Passive Attack Buff Arcane Staff",
        icon: spellIcons.PASSIVE_ATTACKBUFF_ARCANESTAFF,
      },
      {
        name: "Passive Energy Chance Arcane Staff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_ARCANESTAFF,
      },
      {
        name: "Passive Armor Caster Arcane Staff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_ARCANESTAFF,
      },
      {
        name: "Passive Silence Chance",
        icon: spellIcons.PASSIVE_SILENCECHANCE,
      },
    ],
  },

  T8_MAIN_FROSTSTAFF: {
    active1: [
      { name: "Frost Bite", icon: spellIcons.FROST_BITE },
      { name: "Ice Shard", icon: spellIcons.ICESHARD },
      { name: "Shatter", icon: spellIcons.SHATTER_Q },
    ],
    active2: [
      { name: "Frost Bomb (Cast Slow)", icon: spellIcons.FROSTBOMB_CASTSLOW },
      { name: "Frost Beam", icon: spellIcons.FROSTBEAM },
      { name: "Frost Nova", icon: spellIcons.FROSTNOVA },
      { name: "Frost Lance", icon: spellIcons.FROST_LANCE },
      { name: "Ice Sculpture", icon: spellIcons.ICE_SCULPTURE },
    ],
    active3: [{ name: "Freezing Wind", icon: spellIcons.FREEZINGWIND }],
    passive1: [
      { name: "Passive Frost", icon: spellIcons.PASSIVE_FROST },
      {
        name: "Passive Energy Chance Frost Staff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Casting Speed Chance Frost Staff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Spell Power Caster Frost Staff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FROSTSTAFF,
      },
    ],
  },
  T8_2H_FROSTSTAFF: {
    active1: [
      { name: "Frost Bite", icon: spellIcons.FROST_BITE },
      { name: "Ice Shard", icon: spellIcons.ICESHARD },
      { name: "Shatter", icon: spellIcons.SHATTER_Q },
    ],
    active2: [
      { name: "Frost Bomb (Cast Slow)", icon: spellIcons.FROSTBOMB_CASTSLOW },
      { name: "Frost Beam", icon: spellIcons.FROSTBEAM },
      { name: "Frost Nova", icon: spellIcons.FROSTNOVA },
      { name: "Frost Lance", icon: spellIcons.FROST_LANCE },
      { name: "Ice Sculpture", icon: spellIcons.ICE_SCULPTURE },
    ],
    active3: [{ name: "Hail (Multi)", icon: spellIcons.HAIL_MULTI_1 }],
    passive1: [
      { name: "Passive Frost", icon: spellIcons.PASSIVE_FROST },
      {
        name: "Passive Energy Chance Frost Staff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Casting Speed Chance Frost Staff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Spell Power Caster Frost Staff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FROSTSTAFF,
      },
    ],
  },

  T8_2H_GLACIALSTAFF: {
    active1: [
      { name: "Frost Bite", icon: spellIcons.FROST_BITE },
      { name: "Ice Shard", icon: spellIcons.ICESHARD },
      { name: "Shatter", icon: spellIcons.SHATTER_Q },
    ],
    active2: [
      { name: "Frost Bomb (Cast Slow)", icon: spellIcons.FROSTBOMB_CASTSLOW },
      { name: "Frost Beam", icon: spellIcons.FROSTBEAM },
      { name: "Frost Nova", icon: spellIcons.FROSTNOVA },
      { name: "Frost Lance", icon: spellIcons.FROST_LANCE },
      { name: "Ice Sculpture", icon: spellIcons.ICE_SCULPTURE },
    ],
    active3: [{ name: "Ice Storm", icon: spellIcons.ICESTORM2 }],
    passive1: [
      { name: "Passive Frost", icon: spellIcons.PASSIVE_FROST },
      {
        name: "Passive Energy Chance Froststaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Casting Speed Chance Froststaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Spellpower Caster Froststaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FROSTSTAFF,
      },
    ],
  },
  T8_MAIN_FROSTSTAFF_KEEPER: {
    active1: [
      { name: "Frost Bite", icon: spellIcons.FROST_BITE },
      { name: "Ice Shard", icon: spellIcons.ICESHARD },
      { name: "Shatter", icon: spellIcons.SHATTER_Q },
    ],
    active2: [
      { name: "Frost Bomb (Cast Slow)", icon: spellIcons.FROSTBOMB_CASTSLOW },
      { name: "Frost Beam", icon: spellIcons.FROSTBEAM },
      { name: "Frost Nova", icon: spellIcons.FROSTNOVA },
      { name: "Frost Lance", icon: spellIcons.FROST_LANCE },
      { name: "Ice Sculpture", icon: spellIcons.ICE_SCULPTURE },
    ],
    active3: [{ name: "Ice Rock Explode", icon: spellIcons.ICEROCK_EXPLODE }],
    passive1: [
      { name: "Passive Frost", icon: spellIcons.PASSIVE_FROST },
      {
        name: "Passive Energy Chance Froststaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Casting Speed Chance Froststaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Spellpower Caster Froststaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FROSTSTAFF,
      },
    ],
  },
  T8_2H_ICEGAUNTLETS_HELL: {
    active1: [
      { name: "Frost Bite", icon: spellIcons.FROST_BITE },
      { name: "Ice Shard", icon: spellIcons.ICESHARD },
      { name: "Shatter", icon: spellIcons.SHATTER_Q },
    ],
    active2: [
      { name: "Frost Bomb (Cast Slow)", icon: spellIcons.FROSTBOMB_CASTSLOW },
      { name: "Frost Beam", icon: spellIcons.FROSTBEAM },
      { name: "Frost Nova", icon: spellIcons.FROSTNOVA },
      { name: "Frost Lance", icon: spellIcons.FROST_LANCE },
      { name: "Ice Sculpture", icon: spellIcons.ICE_SCULPTURE },
    ],
    active3: [{ name: "Glacial Field", icon: spellIcons.GLACIALFIELD }],
    passive1: [
      { name: "Passive Frost", icon: spellIcons.PASSIVE_FROST },
      {
        name: "Passive Energy Chance Froststaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Casting Speed Chance Froststaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Spellpower Caster Froststaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FROSTSTAFF,
      },
    ],
  },

  T8_2H_ICECRYSTAL_UNDEAD: {
    active1: [
      { name: "Frost Bite", icon: spellIcons.FROST_BITE },
      { name: "Ice Shard", icon: spellIcons.ICESHARD },
      { name: "Shatter", icon: spellIcons.SHATTER_Q },
    ],
    active2: [
      { name: "Frost Bomb (Cast Slow)", icon: spellIcons.FROSTBOMB_CASTSLOW },
      { name: "Frost Beam", icon: spellIcons.FROSTBEAM },
      { name: "Frost Nova", icon: spellIcons.FROSTNOVA },
      { name: "Frost Lance", icon: spellIcons.FROST_LANCE },
      { name: "Ice Sculpture", icon: spellIcons.ICE_SCULPTURE },
    ],
    active3: [{ name: "Frost Ultimate", icon: spellIcons.FROST_ULTIMATE }],
    passive1: [
      { name: "Passive Frost", icon: spellIcons.PASSIVE_FROST },
      {
        name: "Passive Energy Chance Froststaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Casting Speed Chance Froststaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Spellpower Caster Froststaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FROSTSTAFF,
      },
    ],
  },
  T8_MAIN_FROSTSTAFF_AVALON: {
    active1: [
      { name: "Frost Bite", icon: spellIcons.FROST_BITE },
      { name: "Ice Shard", icon: spellIcons.ICESHARD },
      { name: "Shatter", icon: spellIcons.SHATTER_Q },
    ],
    active2: [
      { name: "Frost Bomb (Cast Slow)", icon: spellIcons.FROSTBOMB_CASTSLOW },
      { name: "Frost Beam", icon: spellIcons.FROSTBEAM },
      { name: "Frost Nova", icon: spellIcons.FROSTNOVA },
      { name: "Frost Lance", icon: spellIcons.FROST_LANCE },
      { name: "Ice Sculpture", icon: spellIcons.ICE_SCULPTURE },
    ],
    active3: [{ name: "Frozen Crystal", icon: spellIcons.FROZEN_CRYSTAL }],
    passive1: [
      { name: "Passive Frost", icon: spellIcons.PASSIVE_FROST },
      {
        name: "Passive Energy Chance Froststaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Casting Speed Chance Froststaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Spellpower Caster Froststaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FROSTSTAFF,
      },
    ],
  },
  T8_2H_FROSTSTAFF_CRYSTAL: {
    active1: [
      { name: "Frost Bite", icon: spellIcons.FROST_BITE },
      { name: "Ice Shard", icon: spellIcons.ICESHARD },
      { name: "Shatter", icon: spellIcons.SHATTER_Q },
    ],
    active2: [
      { name: "Frost Bomb (Cast Slow)", icon: spellIcons.FROSTBOMB_CASTSLOW },
      { name: "Frost Beam", icon: spellIcons.FROSTBEAM },
      { name: "Frost Nova", icon: spellIcons.FROSTNOVA },
      { name: "Frost Lance", icon: spellIcons.FROST_LANCE },
      { name: "Ice Sculpture", icon: spellIcons.ICE_SCULPTURE },
    ],
    active3: [
      {
        name: "Frost Targeted Channel",
        icon: spellIcons.FROST_TARGETED_CHANNEL,
      },
    ],
    passive1: [
      { name: "Passive Frost", icon: spellIcons.PASSIVE_FROST },
      {
        name: "Passive Energy Chance Froststaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Casting Speed Chance Froststaff",
        icon: spellIcons.PASSIVE_CASTINGSPEED_CHANCE_FROSTSTAFF,
      },
      {
        name: "Passive Spellpower Caster Froststaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_FROSTSTAFF,
      },
    ],
  },

  T8_MAIN_CURSEDSTAFF: {
    active1: [
      { name: "Curse Dot", icon: spellIcons.CURSEDOT },
      { name: "Curse Blade", icon: spellIcons.CURSEBLADE },
      { name: "Cursed Splat", icon: spellIcons.CURSED_SPLAT },
    ],
    active2: [
      { name: "Armor Piercer", icon: spellIcons.ARMORPIERCER },
      { name: "Curse Nova", icon: spellIcons.CURSENOVA },
      { name: "Cursed Hands Stackup", icon: spellIcons.CURSEDHANDS_STACKUP },
      { name: "Cursed Beam", icon: spellIcons.CURSEDBEAM },
      { name: "Dark Matter", icon: spellIcons.DARKMATTER },
    ],
    active3: [{ name: "Death Curse", icon: spellIcons.DEATHCURSE2 }],
    passive1: [
      { name: "Passive Curse", icon: spellIcons.PASSIVE_CURSE },
      {
        name: "Passive Energy Chance Cursedstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CURSEDSTAFF,
      },
      {
        name: "Passive Spellpower Caster Cursedstaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CURSEDSTAFF,
      },
      {
        name: "Passive Movespeed Chance Cursedstaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_CURSEDSTAFF,
      },
    ],
  },
  T8_2H_CURSEDSTAFF: {
    active1: [
      { name: "Curse Dot", icon: spellIcons.CURSEDOT },
      { name: "Curse Blade", icon: spellIcons.CURSEBLADE },
      { name: "Cursed Splat", icon: spellIcons.CURSED_SPLAT },
    ],
    active2: [
      { name: "Armor Piercer", icon: spellIcons.ARMORPIERCER },
      { name: "Curse Nova", icon: spellIcons.CURSENOVA },
      { name: "Cursed Hands Stackup", icon: spellIcons.CURSEDHANDS_STACKUP },
      { name: "Cursed Beam", icon: spellIcons.CURSEDBEAM },
      { name: "Dark Matter", icon: spellIcons.DARKMATTER },
    ],
    active3: [{ name: "Area of Decay", icon: spellIcons.AREAOFDECAY }],
    passive1: [
      { name: "Passive Curse", icon: spellIcons.PASSIVE_CURSE },
      {
        name: "Passive Energy Chance Cursedstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CURSEDSTAFF,
      },
      {
        name: "Passive Spellpower Caster Cursedstaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CURSEDSTAFF,
      },
      {
        name: "Passive Movespeed Chance Cursedstaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_CURSEDSTAFF,
      },
    ],
  },
  T8_2H_DEMONICSTAFF: {
    active1: [
      { name: "Curse Dot", icon: spellIcons.CURSEDOT },
      { name: "Curse Blade", icon: spellIcons.CURSEBLADE },
      { name: "Cursed Splat", icon: spellIcons.CURSED_SPLAT },
    ],
    active2: [
      { name: "Armor Piercer", icon: spellIcons.ARMORPIERCER },
      { name: "Curse Nova", icon: spellIcons.CURSENOVA },
      { name: "Cursed Hands Stackup", icon: spellIcons.CURSEDHANDS_STACKUP },
      { name: "Cursed Beam", icon: spellIcons.CURSEDBEAM },
      { name: "Dark Matter", icon: spellIcons.DARKMATTER },
    ],
    active3: [{ name: "Cursed Wall", icon: spellIcons.CURSED_WALL }],
    passive1: [
      { name: "Passive Curse", icon: spellIcons.PASSIVE_CURSE },
      {
        name: "Passive Energy Chance Cursedstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CURSEDSTAFF,
      },
      {
        name: "Passive Spellpower Caster Cursedstaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CURSEDSTAFF,
      },
      {
        name: "Passive Movespeed Chance Cursedstaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_CURSEDSTAFF,
      },
    ],
  },

  T8_MAIN_CURSEDSTAFF_UNDEAD: {
    active1: [
      { name: "Curse Dot", icon: spellIcons.CURSEDOT },
      { name: "Curse Blade", icon: spellIcons.CURSEBLADE },
      { name: "Cursed Splat", icon: spellIcons.CURSED_SPLAT },
    ],
    active2: [
      { name: "Armor Piercer", icon: spellIcons.ARMORPIERCER },
      { name: "Curse Nova", icon: spellIcons.CURSENOVA },
      { name: "Cursed Hands Stackup", icon: spellIcons.CURSEDHANDS_STACKUP },
      { name: "Cursed Beam", icon: spellIcons.CURSEDBEAM },
      { name: "Dark Matter", icon: spellIcons.DARKMATTER },
    ],
    active3: [{ name: "Enfeeble Blades", icon: spellIcons.ENFEEBLEBLADES }],
    passive1: [
      { name: "Passive Curse", icon: spellIcons.PASSIVE_CURSE },
      {
        name: "Passive Energy Chance Cursedstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CURSEDSTAFF,
      },
      {
        name: "Passive Spellpower Caster Cursedstaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CURSEDSTAFF,
      },
      {
        name: "Passive Movespeed Chance Cursedstaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_CURSEDSTAFF,
      },
    ],
  },
  T8_2H_SKULLORB_HELL: {
    active1: [
      { name: "Curse Dot", icon: spellIcons.CURSEDOT },
      { name: "Curse Blade", icon: spellIcons.CURSEBLADE },
      { name: "Cursed Splat", icon: spellIcons.CURSED_SPLAT },
    ],
    active2: [
      { name: "Armor Piercer", icon: spellIcons.ARMORPIERCER },
      { name: "Curse Nova", icon: spellIcons.CURSENOVA },
      { name: "Cursed Hands Stackup", icon: spellIcons.CURSEDHANDS_STACKUP },
      { name: "Cursed Beam", icon: spellIcons.CURSEDBEAM },
      { name: "Dark Matter", icon: spellIcons.DARKMATTER },
    ],
    active3: [{ name: "Skull Curse", icon: spellIcons.SKULLCURSE }],
    passive1: [
      { name: "Passive Curse", icon: spellIcons.PASSIVE_CURSE },
      {
        name: "Passive Energy Chance Cursedstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CURSEDSTAFF,
      },
      {
        name: "Passive Spellpower Caster Cursedstaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CURSEDSTAFF,
      },
      {
        name: "Passive Movespeed Chance Cursedstaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_CURSEDSTAFF,
      },
    ],
  },

  T8_2H_CURSEDSTAFF_MORGANA: {
    active1: [
      { name: "Curse Dot", icon: spellIcons.CURSEDOT },
      { name: "Curse Blade", icon: spellIcons.CURSEBLADE },
      { name: "Cursed Splat", icon: spellIcons.CURSED_SPLAT },
    ],
    active2: [
      { name: "Armor Piercer", icon: spellIcons.ARMORPIERCER },
      { name: "Curse Nova", icon: spellIcons.CURSENOVA },
      { name: "Cursed Hands Stackup", icon: spellIcons.CURSEDHANDS_STACKUP },
      { name: "Cursed Beam", icon: spellIcons.CURSEDBEAM },
      { name: "Dark Matter", icon: spellIcons.DARKMATTER },
    ],
    active3: [{ name: "Curse Ultimate", icon: spellIcons.CURSEULTIMATE }],
    passive1: [
      { name: "Passive Curse", icon: spellIcons.PASSIVE_CURSE },
      {
        name: "Passive Energy Chance Cursedstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CURSEDSTAFF,
      },
      {
        name: "Passive Spellpower Caster Cursedstaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CURSEDSTAFF,
      },
      {
        name: "Passive Movespeed Chance Cursedstaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_CURSEDSTAFF,
      },
    ],
  },
  T8_MAIN_CURSEDSTAFF_AVALON: {
    active1: [
      { name: "Curse Dot", icon: spellIcons.CURSEDOT },
      { name: "Curse Blade", icon: spellIcons.CURSEBLADE },
      { name: "Cursed Splat", icon: spellIcons.CURSED_SPLAT },
    ],
    active2: [
      { name: "Armor Piercer", icon: spellIcons.ARMORPIERCER },
      { name: "Curse Nova", icon: spellIcons.CURSENOVA },
      { name: "Cursed Hands Stackup", icon: spellIcons.CURSEDHANDS_STACKUP },
      { name: "Cursed Beam", icon: spellIcons.CURSEDBEAM },
      { name: "Dark Matter", icon: spellIcons.DARKMATTER },
    ],
    active3: [{ name: "Dynamic Curse", icon: spellIcons.DYNAMIC_CURSE }],
    passive1: [
      { name: "Passive Curse", icon: spellIcons.PASSIVE_CURSE },
      {
        name: "Passive Energy Chance Cursedstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CURSEDSTAFF,
      },
      {
        name: "Passive Spellpower Caster Cursedstaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CURSEDSTAFF,
      },
      {
        name: "Passive Movespeed Chance Cursedstaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_CURSEDSTAFF,
      },
    ],
  },
  T8_MAIN_CURSEDSTAFF_CRYSTAL: {
    active1: [
      { name: "Curse Dot", icon: spellIcons.CURSEDOT },
      { name: "Curse Blade", icon: spellIcons.CURSEBLADE },
      { name: "Cursed Splat", icon: spellIcons.CURSED_SPLAT },
    ],
    active2: [
      { name: "Armor Piercer", icon: spellIcons.ARMORPIERCER },
      { name: "Curse Nova", icon: spellIcons.CURSENOVA },
      { name: "Cursed Hands Stackup", icon: spellIcons.CURSEDHANDS_STACKUP },
      { name: "Cursed Beam", icon: spellIcons.CURSEDBEAM },
      { name: "Dark Matter", icon: spellIcons.DARKMATTER },
    ],
    active3: [
      {
        name: "Curse Skeleton Barf Fdhr",
        icon: spellIcons.CURSE_SKELETON_BARF_FDHR,
      },
    ],
    passive1: [
      { name: "Passive Curse", icon: spellIcons.PASSIVE_CURSE },
      {
        name: "Passive Energy Chance Cursedstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CURSEDSTAFF,
      },
      {
        name: "Passive Spellpower Caster Cursedstaff",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CURSEDSTAFF,
      },
      {
        name: "Passive Movespeed Chance Cursedstaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_CURSEDSTAFF,
      },
    ],
  },

  T8_2H_BOW: {
    active1: [
      { name: "Multishot 2", icon: spellIcons.MULTISHOT2 },
      { name: "Deadly Shot", icon: spellIcons.DEADLYSHOT },
      { name: "Poison Arrow", icon: spellIcons.POISONARROW },
    ],
    active2: [
      { name: "Ground Arrow", icon: spellIcons.GROUNDARROW },
      { name: "Jump Shot 2", icon: spellIcons.JUMPSHOT2 },
      { name: "Speed Shot 2", icon: spellIcons.SPEEDSHOT2 },
      { name: "Burning Arrows", icon: spellIcons.BURNINGARROWS },
    ],
    active3: [{ name: "Speed Archer Kite", icon: spellIcons.SPEEDARCHER_KITE }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Energy Chance Bow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_BOW,
      },
      {
        name: "Passive Armor Pierce Stack",
        icon: spellIcons.PASSIVE_ARMOR_PIERCE_STACK,
      },
      {
        name: "Passive AA Speed Chance Bow",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_BOW,
      },
    ],
  },
  T8_2H_WARBOW: {
    active1: [
      { name: "Multishot 2", icon: spellIcons.MULTISHOT2 },
      { name: "Deadly Shot", icon: spellIcons.DEADLYSHOT },
      { name: "Poison Arrow", icon: spellIcons.POISONARROW },
    ],
    active2: [
      { name: "Ground Arrow", icon: spellIcons.GROUNDARROW },
      { name: "Jump Shot 2", icon: spellIcons.JUMPSHOT2 },
      { name: "Speed Shot 2", icon: spellIcons.SPEEDSHOT2 },
      { name: "Burning Arrows", icon: spellIcons.BURNINGARROWS },
    ],
    active3: [{ name: "Skillshot Stun", icon: spellIcons.SKILLSHOT_STUN }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Energy Chance Bow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_BOW,
      },
      {
        name: "Passive Armor Pierce Stack",
        icon: spellIcons.PASSIVE_ARMOR_PIERCE_STACK,
      },
      {
        name: "Passive AA Speed Chance Bow",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_BOW,
      },
    ],
  },

  T8_2H_LONGBOW: {
    active1: [
      { name: "Multishot 2", icon: spellIcons.MULTISHOT2 },
      { name: "Deadly Shot", icon: spellIcons.DEADLYSHOT },
      { name: "Poison Arrow", icon: spellIcons.POISONARROW },
    ],
    active2: [
      { name: "Ground Arrow", icon: spellIcons.GROUNDARROW },
      { name: "Jump Shot 2", icon: spellIcons.JUMPSHOT2 },
      { name: "Speed Shot 2", icon: spellIcons.SPEEDSHOT2 },
      { name: "Burning Arrows", icon: spellIcons.BURNINGARROWS },
    ],
    active3: [{ name: "Arrow Rain", icon: spellIcons.ARROWRAIN }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Energy Chance Bow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_BOW,
      },
      {
        name: "Passive Armor Pierce Stack",
        icon: spellIcons.PASSIVE_ARMOR_PIERCE_STACK,
      },
      {
        name: "Passive AA Speed Chance Bow",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_BOW,
      },
    ],
  },
  T8_2H_LONGBOW_UNDEAD: {
    active1: [
      { name: "Multishot 2", icon: spellIcons.MULTISHOT2 },
      { name: "Deadly Shot", icon: spellIcons.DEADLYSHOT },
      { name: "Poison Arrow", icon: spellIcons.POISONARROW },
    ],
    active2: [
      { name: "Ground Arrow", icon: spellIcons.GROUNDARROW },
      { name: "Jump Shot 2", icon: spellIcons.JUMPSHOT2 },
      { name: "Speed Shot 2", icon: spellIcons.SPEEDSHOT2 },
      { name: "Burning Arrows", icon: spellIcons.BURNINGARROWS },
    ],
    active3: [{ name: "Undead Arrows", icon: spellIcons.UNDEADARROWS }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Energy Chance Bow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_BOW,
      },
      {
        name: "Passive Armor Pierce Stack",
        icon: spellIcons.PASSIVE_ARMOR_PIERCE_STACK,
      },
      {
        name: "Passive AA Speed Chance Bow",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_BOW,
      },
    ],
  },
  T8_2H_BOW_HELL: {
    active1: [
      { name: "Multishot 2", icon: spellIcons.MULTISHOT2 },
      { name: "Deadly Shot", icon: spellIcons.DEADLYSHOT },
      { name: "Poison Arrow", icon: spellIcons.POISONARROW },
    ],
    active2: [
      { name: "Ground Arrow", icon: spellIcons.GROUNDARROW },
      { name: "Jump Shot 2", icon: spellIcons.JUMPSHOT2 },
      { name: "Speed Shot 2", icon: spellIcons.SPEEDSHOT2 },
      { name: "Burning Arrows", icon: spellIcons.BURNINGARROWS },
    ],
    active3: [{ name: "Hell Arrow", icon: spellIcons.HELL_ARROW }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Energy Chance Bow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_BOW,
      },
      {
        name: "Passive Armor Pierce Stack",
        icon: spellIcons.PASSIVE_ARMOR_PIERCE_STACK,
      },
      {
        name: "Passive AA Speed Chance Bow",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_BOW,
      },
    ],
  },
  T8_2H_BOW_KEEPER: {
    active1: [
      { name: "Multishot 2", icon: spellIcons.MULTISHOT2 },
      { name: "Deadly Shot", icon: spellIcons.DEADLYSHOT },
      { name: "Poison Arrow", icon: spellIcons.POISONARROW },
    ],
    active2: [
      { name: "Ground Arrow", icon: spellIcons.GROUNDARROW },
      { name: "Jump Shot 2", icon: spellIcons.JUMPSHOT2 },
      { name: "Speed Shot 2", icon: spellIcons.SPEEDSHOT2 },
      { name: "Burning Arrows", icon: spellIcons.BURNINGARROWS },
    ],
    active3: [{ name: "Lightning Arrow", icon: spellIcons.LIGHTNING_ARROW }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Energy Chance Bow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_BOW,
      },
      {
        name: "Passive Armor Pierce Stack",
        icon: spellIcons.PASSIVE_ARMOR_PIERCE_STACK,
      },
      {
        name: "Passive AA Speed Chance Bow",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_BOW,
      },
    ],
  },
  T8_2H_BOW_AVALON: {
    active1: [
      { name: "Multishot 2", icon: spellIcons.MULTISHOT2 },
      { name: "Deadly Shot", icon: spellIcons.DEADLYSHOT },
      { name: "Poison Arrow", icon: spellIcons.POISONARROW },
    ],
    active2: [
      { name: "Ground Arrow", icon: spellIcons.GROUNDARROW },
      { name: "Jump Shot 2", icon: spellIcons.JUMPSHOT2 },
      { name: "Speed Shot 2", icon: spellIcons.SPEEDSHOT2 },
      { name: "Burning Arrows", icon: spellIcons.BURNINGARROWS },
    ],
    active3: [{ name: "Hawk Shot Multi 1", icon: spellIcons.HAWK_SHOT_MULTI1 }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Energy Chance Bow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_BOW,
      },
      {
        name: "Passive Armor Pierce Stack",
        icon: spellIcons.PASSIVE_ARMOR_PIERCE_STACK,
      },
      {
        name: "Passive AA Speed Chance Bow",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_BOW,
      },
    ],
  },
  T8_2H_BOW_CRYSTAL: {
    active1: [
      { name: "Multishot 2", icon: spellIcons.MULTISHOT2 },
      { name: "Deadly Shot", icon: spellIcons.DEADLYSHOT },
      { name: "Poison Arrow", icon: spellIcons.POISONARROW },
    ],
    active2: [
      { name: "Ground Arrow", icon: spellIcons.GROUNDARROW },
      { name: "Jump Shot 2", icon: spellIcons.JUMPSHOT2 },
      { name: "Speed Shot 2", icon: spellIcons.SPEEDSHOT2 },
      { name: "Burning Arrows", icon: spellIcons.BURNINGARROWS },
    ],
    active3: [{ name: "Air Raid", icon: spellIcons.AIR_RAID }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Energy Chance Bow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_BOW,
      },
      {
        name: "Passive Armor Pierce Stack",
        icon: spellIcons.PASSIVE_ARMOR_PIERCE_STACK,
      },
      {
        name: "Passive AA Speed Chance Bow",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_BOW,
      },
    ],
  },

  T8_MAIN_DAGGER: {
    active1: [
      { name: "Sunder Armor 2", icon: spellIcons.SUNDERARMOR2 },
      { name: "Q Dash", icon: spellIcons.QDASH },
      { name: "Assassin Spirit", icon: spellIcons.ASSASSINSPIRIT },
    ],
    active2: [
      { name: "Throwing Blades", icon: spellIcons.THROWINGBLADES },
      { name: "Ground Dash", icon: spellIcons.GROUNDDASH },
      { name: "Deep Cuts", icon: spellIcons.DEEPCUTS },
      { name: "Skillshot Teleport", icon: spellIcons.SKILLSHOT_TELEPORT },
      { name: "Chain Dash", icon: spellIcons.CHAINDASH },
    ],
    active3: [
      { name: "Bloodthirsty Blade", icon: spellIcons.BLOODTHIRSTYBLADE },
    ],
    passive1: [
      { name: "Passive Bleed Chance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Health Chance Dagger",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_DAGGER,
      },
      {
        name: "Passive AA Speed Chance Dagger",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_DAGGER,
      },
      {
        name: "Passive Spellpower Chance Dagger",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_DAGGER,
      },
    ],
  },
  T8_2H_DAGGERPAIR: {
    active1: [
      { name: "Sunder Armor 2", icon: spellIcons.SUNDERARMOR2 },
      { name: "Q Dash", icon: spellIcons.QDASH },
      { name: "Assassin Spirit", icon: spellIcons.ASSASSINSPIRIT },
    ],
    active2: [
      { name: "Throwing Blades", icon: spellIcons.THROWINGBLADES },
      { name: "Ground Dash", icon: spellIcons.GROUNDDASH },
      { name: "Deep Cuts", icon: spellIcons.DEEPCUTS },
      { name: "Skillshot Teleport", icon: spellIcons.SKILLSHOT_TELEPORT },
      { name: "Chain Dash", icon: spellIcons.CHAINDASH },
    ],
    active3: [{ name: "Execute Dagger", icon: spellIcons.EXECUTEDAGGER }],
    passive1: [
      { name: "Passive Bleed Chance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Health Chance Dagger",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_DAGGER,
      },
      {
        name: "Passive AA Speed Chance Dagger",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_DAGGER,
      },
      {
        name: "Passive Spellpower Chance Dagger",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_DAGGER,
      },
    ],
  },
  T8_2H_CLAWPAIR: {
    active1: [
      { name: "Sunder Armor 2", icon: spellIcons.SUNDERARMOR2 },
      { name: "Q Dash", icon: spellIcons.QDASH },
      { name: "Assassin Spirit", icon: spellIcons.ASSASSINSPIRIT },
    ],
    active2: [
      { name: "Throwing Blades", icon: spellIcons.THROWINGBLADES },
      { name: "Ground Dash", icon: spellIcons.GROUNDDASH },
      { name: "Deep Cuts", icon: spellIcons.DEEPCUTS },
      { name: "Skillshot Teleport", icon: spellIcons.SKILLSHOT_TELEPORT },
      { name: "Chain Dash", icon: spellIcons.CHAINDASH },
    ],
    active3: [{ name: "Disembowel", icon: spellIcons.DISEMBOWEL }],
    passive1: [
      { name: "Passive Bleed Chance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Health Chance Dagger",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_DAGGER,
      },
      {
        name: "Passive AA Speed Chance Dagger",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_DAGGER,
      },
      {
        name: "Passive Spellpower Chance Dagger",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_DAGGER,
      },
    ],
  },

  T8_MAIN_RAPIER_MORGANA: {
    active1: [
      { name: "Sunder Armor 2", icon: spellIcons.SUNDERARMOR2 },
      { name: "Q Dash", icon: spellIcons.QDASH },
      { name: "Assassin Spirit", icon: spellIcons.ASSASSINSPIRIT },
    ],
    active2: [
      { name: "Throwing Blades", icon: spellIcons.THROWINGBLADES },
      { name: "Ground Dash", icon: spellIcons.GROUNDDASH },
      { name: "Deep Cuts", icon: spellIcons.DEEPCUTS },
      { name: "Skillshot Teleport", icon: spellIcons.SKILLSHOT_TELEPORT },
      { name: "Chain Dash", icon: spellIcons.CHAINDASH },
    ],
    active3: [{ name: "Rapier Stab", icon: spellIcons.RAPIERSTAB }],
    passive1: [
      { name: "Passive Bleed Chance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Health Chance Dagger",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_DAGGER,
      },
      {
        name: "Passive AA Speed Chance Dagger",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_DAGGER,
      },
      {
        name: "Passive Spellpower Chance Dagger",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_DAGGER,
      },
    ],
  },
  T8_MAIN_DAGGER_HELL: {
    active1: [
      { name: "Sunder Armor 2", icon: spellIcons.SUNDERARMOR2 },
      { name: "Q Dash", icon: spellIcons.QDASH },
      { name: "Assassin Spirit", icon: spellIcons.ASSASSINSPIRIT },
    ],
    active2: [
      { name: "Throwing Blades", icon: spellIcons.THROWINGBLADES },
      { name: "Ground Dash", icon: spellIcons.GROUNDDASH },
      { name: "Deep Cuts", icon: spellIcons.DEEPCUTS },
      { name: "Skillshot Teleport", icon: spellIcons.SKILLSHOT_TELEPORT },
      { name: "Chain Dash", icon: spellIcons.CHAINDASH },
    ],
    active3: [{ name: "Blood Blade", icon: spellIcons.BLOOD_BLADE }],
    passive1: [
      { name: "Passive Bleed Chance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Health Chance Dagger",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_DAGGER,
      },
      {
        name: "Passive AA Speed Chance Dagger",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_DAGGER,
      },
      {
        name: "Passive Spellpower Chance Dagger",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_DAGGER,
      },
    ],
  },
  T8_2H_DUALSICKLE_UNDEAD: {
    active1: [
      { name: "Sunder Armor 2", icon: spellIcons.SUNDERARMOR2 },
      { name: "Q Dash", icon: spellIcons.QDASH },
      { name: "Assassin Spirit", icon: spellIcons.ASSASSINSPIRIT },
    ],
    active2: [
      { name: "Throwing Blades", icon: spellIcons.THROWINGBLADES },
      { name: "Ground Dash", icon: spellIcons.GROUNDDASH },
      { name: "Deep Cuts", icon: spellIcons.DEEPCUTS },
      { name: "Skillshot Teleport", icon: spellIcons.SKILLSHOT_TELEPORT },
      { name: "Chain Dash", icon: spellIcons.CHAINDASH },
    ],
    active3: [{ name: "Ghost Strike", icon: spellIcons.GHOSTSTRIKE }],
    passive1: [
      { name: "Passive Bleed Chance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Health Chance Dagger",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_DAGGER,
      },
      {
        name: "Passive AA Speed Chance Dagger",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_DAGGER,
      },
      {
        name: "Passive Spellpower Chance Dagger",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_DAGGER,
      },
    ],
  },

  T8_2H_DAGGER_KATAR_AVALON: {
    active1: [
      { name: "Sunder Armor 2", icon: spellIcons.SUNDERARMOR2 },
      { name: "Q Dash", icon: spellIcons.QDASH },
      { name: "Assassin Spirit", icon: spellIcons.ASSASSINSPIRIT },
    ],
    active2: [
      { name: "Throwing Blades", icon: spellIcons.THROWINGBLADES },
      { name: "Ground Dash", icon: spellIcons.GROUNDDASH },
      { name: "Deep Cuts", icon: spellIcons.DEEPCUTS },
      { name: "Skillshot Teleport", icon: spellIcons.SKILLSHOT_TELEPORT },
      { name: "Chain Dash", icon: spellIcons.CHAINDASH },
    ],
    active3: [{ name: "Back Slash", icon: spellIcons.BACK_SLASH }],
    passive1: [
      { name: "Passive Bleed Chance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Health Chance Dagger",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_DAGGER,
      },
      {
        name: "Passive AA Speed Chance Dagger",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_DAGGER,
      },
      {
        name: "Passive Spellpower Chance Dagger",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_DAGGER,
      },
    ],
  },
  T8_2H_DAGGERPAIR_CRYSTAL: {
    active1: [
      { name: "Sunder Armor 2", icon: spellIcons.SUNDERARMOR2 },
      { name: "Q Dash", icon: spellIcons.QDASH },
      { name: "Assassin Spirit", icon: spellIcons.ASSASSINSPIRIT },
    ],
    active2: [
      { name: "Throwing Blades", icon: spellIcons.THROWINGBLADES },
      { name: "Ground Dash", icon: spellIcons.GROUNDDASH },
      { name: "Deep Cuts", icon: spellIcons.DEEPCUTS },
      { name: "Skillshot Teleport", icon: spellIcons.SKILLSHOT_TELEPORT },
      { name: "Chain Dash", icon: spellIcons.CHAINDASH },
    ],
    active3: [
      {
        name: "Crystal Dagger Blade Ring",
        icon: spellIcons.CRYSTAL_DAGGER_BLADE_RING,
      },
    ],
    passive1: [
      { name: "Passive Bleed Chance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Health Chance Dagger",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_DAGGER,
      },
      {
        name: "Passive AA Speed Chance Dagger",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_DAGGER,
      },
      {
        name: "Passive Spellpower Chance Dagger",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_DAGGER,
      },
    ],
  },
  T8_MAIN_SPEAR: {
    active1: [
      { name: "Spear Lunge", icon: spellIcons.SPEAR_LUNGE },
      { name: "Spirit Spear", icon: spellIcons.SPIRITSPEAR },
    ],
    active2: [
      { name: "Forest of Spears", icon: spellIcons.FORESTOFSPEARS },
      { name: "Charging Blade", icon: spellIcons.CHARGINGBLADE },
      { name: "Leg Breaker", icon: spellIcons.LEGBREAKER },
      { name: "Deflecting Stance", icon: spellIcons.DEFLECTINGSTANCE },
      { name: "Ground Spear", icon: spellIcons.GROUNDSPEAR },
      { name: "Skillshot Pull", icon: spellIcons.SKILLSHOT_PULL },
    ],
    active3: [{ name: "Dash Damage", icon: spellIcons.DASHDMG }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Health Chance Spear",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_SPEAR,
      },
      {
        name: "Passive Spellpower Chance Spear",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_SPEAR,
      },
      {
        name: "Passive AA Speed Chance Spear",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_SPEAR,
      },
    ],
  },
  T8_2H_SPEAR: {
    active1: [
      { name: "Spear Lunge", icon: spellIcons.SPEAR_LUNGE },
      { name: "Spirit Spear", icon: spellIcons.SPIRITSPEAR },
    ],
    active2: [
      { name: "Forest of Spears", icon: spellIcons.FORESTOFSPEARS },
      { name: "Charging Blade", icon: spellIcons.CHARGINGBLADE },
      { name: "Leg Breaker", icon: spellIcons.LEGBREAKER },
      { name: "Deflecting Stance", icon: spellIcons.DEFLECTINGSTANCE },
      { name: "Ground Spear", icon: spellIcons.GROUNDSPEAR },
      { name: "Skillshot Pull", icon: spellIcons.SKILLSHOT_PULL },
    ],
    active3: [{ name: "Halberd Smash", icon: spellIcons.HALBERDSMASH }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Health Chance Spear",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_SPEAR,
      },
      {
        name: "Passive Spellpower Chance Spear",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_SPEAR,
      },
      {
        name: "Passive AA Speed Chance Spear",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_SPEAR,
      },
    ],
  },
  T8_2H_GLAIVE: {
    active1: [
      { name: "Spear Lunge", icon: spellIcons.SPEAR_LUNGE },
      { name: "Spirit Spear", icon: spellIcons.SPIRITSPEAR },
    ],
    active2: [
      { name: "Forest of Spears", icon: spellIcons.FORESTOFSPEARS },
      { name: "Charging Blade", icon: spellIcons.CHARGINGBLADE },
      { name: "Leg Breaker", icon: spellIcons.LEGBREAKER },
      { name: "Deflecting Stance", icon: spellIcons.DEFLECTINGSTANCE },
      { name: "Ground Spear", icon: spellIcons.GROUNDSPEAR },
      { name: "Skillshot Pull", icon: spellIcons.SKILLSHOT_PULL },
    ],
    active3: [{ name: "Shovel", icon: spellIcons.SHOVEL }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Health Chance Spear",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_SPEAR,
      },
      {
        name: "Passive Spellpower Chance Spear",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_SPEAR,
      },
      {
        name: "Passive AA Speed Chance Spear",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_SPEAR,
      },
    ],
  },

  T8_MAIN_SPEAR_KEEPER: {
    active1: [
      { name: "Spear Lunge", icon: spellIcons.SPEAR_LUNGE },
      { name: "Spirit Spear", icon: spellIcons.SPIRITSPEAR },
    ],
    active2: [
      { name: "Forest of Spears", icon: spellIcons.FORESTOFSPEARS },
      { name: "Charging Blade", icon: spellIcons.CHARGINGBLADE },
      { name: "Leg Breaker", icon: spellIcons.LEGBREAKER },
      { name: "Deflecting Stance", icon: spellIcons.DEFLECTINGSTANCE },
      { name: "Ground Spear", icon: spellIcons.GROUNDSPEAR },
      { name: "Skillshot Pull", icon: spellIcons.SKILLSHOT_PULL },
    ],
    active3: [{ name: "Tainted Steel", icon: spellIcons.TAINTED_STEEL }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Health Chance Spear",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_SPEAR,
      },
      {
        name: "Passive Spellpower Chance Spear",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_SPEAR,
      },
      {
        name: "Passive AA Speed Chance Spear",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_SPEAR,
      },
    ],
  },

  T8_2H_HARPOON_HELL: {
    active1: [
      { name: "Spear Lunge", icon: spellIcons.SPEAR_LUNGE },
      { name: "Spirit Spear", icon: spellIcons.SPIRITSPEAR },
    ],
    active2: [
      { name: "Forest of Spears", icon: spellIcons.FORESTOFSPEARS },
      { name: "Charging Blade", icon: spellIcons.CHARGINGBLADE },
      { name: "Leg Breaker", icon: spellIcons.LEGBREAKER },
      { name: "Deflecting Stance", icon: spellIcons.DEFLECTINGSTANCE },
      { name: "Ground Spear", icon: spellIcons.GROUNDSPEAR },
      { name: "Skillshot Pull", icon: spellIcons.SKILLSHOT_PULL },
    ],
    active3: [{ name: "Spear Throw", icon: spellIcons.SPEARTHROW }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Health Chance Spear",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_SPEAR,
      },
      {
        name: "Passive Spellpower Chance Spear",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_SPEAR,
      },
      {
        name: "Passive AA Speed Chance Spear",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_SPEAR,
      },
    ],
  },

  T8_2H_TRIDENT_UNDEAD: {
    active1: [
      { name: "Spear Lunge", icon: spellIcons.SPEAR_LUNGE },
      { name: "Spirit Spear", icon: spellIcons.SPIRITSPEAR },
    ],
    active2: [
      { name: "Forest of Spears", icon: spellIcons.FORESTOFSPEARS },
      { name: "Charging Blade", icon: spellIcons.CHARGINGBLADE },
      { name: "Leg Breaker", icon: spellIcons.LEGBREAKER },
      { name: "Deflecting Stance", icon: spellIcons.DEFLECTINGSTANCE },
      { name: "Ground Spear", icon: spellIcons.GROUNDSPEAR },
      { name: "Skillshot Pull", icon: spellIcons.SKILLSHOT_PULL },
    ],
    active3: [{ name: "Trident Throw", icon: spellIcons.TRIDENTTHROW }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Health Chance Spear",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_SPEAR,
      },
      {
        name: "Passive Spellpower Chance Spear",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_SPEAR,
      },
      {
        name: "Passive AA Speed Chance Spear",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_SPEAR,
      },
    ],
  },
  T8_MAIN_SPEAR_LANCE_AVALON: {
    active1: [
      { name: "Spear Lunge", icon: spellIcons.SPEAR_LUNGE },
      { name: "Spirit Spear", icon: spellIcons.SPIRITSPEAR },
    ],
    active2: [
      { name: "Forest of Spears", icon: spellIcons.FORESTOFSPEARS },
      { name: "Charging Blade", icon: spellIcons.CHARGINGBLADE },
      { name: "Leg Breaker", icon: spellIcons.LEGBREAKER },
      { name: "Deflecting Stance", icon: spellIcons.DEFLECTINGSTANCE },
      { name: "Ground Spear", icon: spellIcons.GROUNDSPEAR },
      { name: "Skillshot Pull", icon: spellIcons.SKILLSHOT_PULL },
    ],
    active3: [{ name: "Lance Charge", icon: spellIcons.LANCE_CHARGE }],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Health Chance Spear",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_SPEAR,
      },
      {
        name: "Passive Spellpower Chance Spear",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_SPEAR,
      },
      {
        name: "Passive AA Speed Chance Spear",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_SPEAR,
      },
    ],
  },

  T8_2H_GLAIVE_CRYSTAL: {
    active1: [
      { name: "Spear Lunge", icon: spellIcons.SPEAR_LUNGE },
      { name: "Spirit Spear", icon: spellIcons.SPIRITSPEAR },
    ],
    active2: [
      { name: "Forest of Spears", icon: spellIcons.FORESTOFSPEARS },
      { name: "Charging Blade", icon: spellIcons.CHARGINGBLADE },
      { name: "Leg Breaker", icon: spellIcons.LEGBREAKER },
      { name: "Deflecting Stance", icon: spellIcons.DEFLECTINGSTANCE },
      { name: "Ground Spear", icon: spellIcons.GROUNDSPEAR },
      { name: "Skillshot Pull", icon: spellIcons.SKILLSHOT_PULL },
    ],
    active3: [
      { name: "Spear AOE Finisher", icon: spellIcons.SPEAR_AOE_FINISHER },
    ],
    passive1: [
      { name: "Passive Slow Poison", icon: spellIcons.PASSIVE_SLOWPOISON },
      {
        name: "Passive Health Chance Spear",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_SPEAR,
      },
      {
        name: "Passive Spellpower Chance Spear",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_SPEAR,
      },
      {
        name: "Passive AA Speed Chance Spear",
        icon: spellIcons.PASSIVE_AASPEEDCHANCE_SPEAR,
      },
    ],
  },
  T8_2H_QUARTERSTAFF: {
    active1: [
      {
        name: "Concussive Blow Multi 1",
        icon: spellIcons.CONCUSSIVEBLOW_MULTI_1,
      },
      { name: "Whirling Staff", icon: spellIcons.WHIRLING_STAFF },
      { name: "Cartwheel", icon: spellIcons.CARTWHEEL },
    ],
    active2: [
      { name: "Qstaff Combo", icon: spellIcons.QSTAFF_COMBO },
      { name: "Stun Run", icon: spellIcons.STUNRUN },
      { name: "Qs Whirlwind 2", icon: spellIcons.QS_WHIRLWIND2 },
      { name: "Launcher", icon: spellIcons.LAUNCHER },
      { name: "Separating Slam", icon: spellIcons.SEPARATING_SLAM },
    ],
    active3: [{ name: "Vault Attack", icon: spellIcons.VAULT_ATTACK }],
    passive1: [
      {
        name: "Passive Stun Chance Quarterstaff",
        icon: spellIcons.PASSIVE_STUNCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Energy Chance Quarterstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Health Chance Quarterstaff",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive CC Duration Chance Quarterstaff",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_QUARTERSTAFF,
      },
    ],
  },
  T8_2H_IRONCLADEDSTAFF: {
    active1: [
      {
        name: "Concussive Blow Multi 1",
        icon: spellIcons.CONCUSSIVEBLOW_MULTI_1,
      },
      { name: "Whirling Staff", icon: spellIcons.WHIRLING_STAFF },
      { name: "Cartwheel", icon: spellIcons.CARTWHEEL },
    ],
    active2: [
      { name: "Qstaff Combo", icon: spellIcons.QSTAFF_COMBO },
      { name: "Stun Run", icon: spellIcons.STUNRUN },
      { name: "Qs Whirlwind 2", icon: spellIcons.QS_WHIRLWIND2 },
      { name: "Launcher", icon: spellIcons.LAUNCHER },
      { name: "Separating Slam", icon: spellIcons.SEPARATING_SLAM },
    ],
    active3: [{ name: "Qs Whirlwind", icon: spellIcons.QSWHIRLWIND }],
    passive1: [
      {
        name: "Passive Stun Chance Quarterstaff",
        icon: spellIcons.PASSIVE_STUNCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Energy Chance Quarterstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Health Chance Quarterstaff",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive CC Duration Chance Quarterstaff",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_QUARTERSTAFF,
      },
    ],
  },
  T8_2H_DOUBLEBLADEDSTAFF: {
    active1: [
      {
        name: "Concussive Blow Multi 1",
        icon: spellIcons.CONCUSSIVEBLOW_MULTI_1,
      },
      { name: "Whirling Staff", icon: spellIcons.WHIRLING_STAFF },
      { name: "Cartwheel", icon: spellIcons.CARTWHEEL },
    ],
    active2: [
      { name: "Qstaff Combo", icon: spellIcons.QSTAFF_COMBO },
      { name: "Stun Run", icon: spellIcons.STUNRUN },
      { name: "Qs Whirlwind 2", icon: spellIcons.QS_WHIRLWIND2 },
      { name: "Launcher", icon: spellIcons.LAUNCHER },
      { name: "Separating Slam", icon: spellIcons.SEPARATING_SLAM },
    ],
    active3: [{ name: "Dash Knockback", icon: spellIcons.DASH_KNOCKBACK }],
    passive1: [
      {
        name: "Passive Stun Chance Quarterstaff",
        icon: spellIcons.PASSIVE_STUNCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Energy Chance Quarterstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Health Chance Quarterstaff",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive CC Duration Chance Quarterstaff",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_QUARTERSTAFF,
      },
    ],
  },
  T8_2H_COMBATSTAFF_MORGANA: {
    active1: [
      {
        name: "Concussive Blow Multi 1",
        icon: spellIcons.CONCUSSIVEBLOW_MULTI_1,
      },
      { name: "Whirling Staff", icon: spellIcons.WHIRLING_STAFF },
      { name: "Cartwheel", icon: spellIcons.CARTWHEEL },
    ],
    active2: [
      { name: "Qstaff Combo", icon: spellIcons.QSTAFF_COMBO },
      { name: "Stun Run", icon: spellIcons.STUNRUN },
      { name: "Qs Whirlwind 2", icon: spellIcons.QS_WHIRLWIND2 },
      { name: "Launcher", icon: spellIcons.LAUNCHER },
      { name: "Separating Slam", icon: spellIcons.SEPARATING_SLAM },
    ],
    active3: [
      { name: "Combatstaff Slash", icon: spellIcons.COMBATSTAFF_SLASH },
    ],
    passive1: [
      {
        name: "Passive Stun Chance Quarterstaff",
        icon: spellIcons.PASSIVE_STUNCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Energy Chance Quarterstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Health Chance Quarterstaff",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive CC Duration Chance Quarterstaff",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_QUARTERSTAFF,
      },
    ],
  },
  T8_2H_TWINSCYTHE_HELL: {
    active1: [
      {
        name: "Concussive Blow Multi 1",
        icon: spellIcons.CONCUSSIVEBLOW_MULTI_1,
      },
      { name: "Whirling Staff", icon: spellIcons.WHIRLING_STAFF },
      { name: "Cartwheel", icon: spellIcons.CARTWHEEL },
    ],
    active2: [
      { name: "Qstaff Combo", icon: spellIcons.QSTAFF_COMBO },
      { name: "Stun Run", icon: spellIcons.STUNRUN },
      { name: "Qs Whirlwind 2", icon: spellIcons.QS_WHIRLWIND2 },
      { name: "Launcher", icon: spellIcons.LAUNCHER },
      { name: "Separating Slam", icon: spellIcons.SEPARATING_SLAM },
    ],
    active3: [{ name: "Tornado", icon: spellIcons.TORNADO }],
    passive1: [
      {
        name: "Passive Stun Chance Quarterstaff",
        icon: spellIcons.PASSIVE_STUNCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Energy Chance Quarterstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Health Chance Quarterstaff",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive CC Duration Chance Quarterstaff",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_QUARTERSTAFF,
      },
    ],
  },

  T8_2H_ROCKSTAFF_KEEPER: {
    active1: [
      {
        name: "Concussive Blow Multi 1",
        icon: spellIcons.CONCUSSIVEBLOW_MULTI_1,
      },
      { name: "Whirling Staff", icon: spellIcons.WHIRLING_STAFF },
      { name: "Cartwheel", icon: spellIcons.CARTWHEEL },
    ],
    active2: [
      { name: "Qstaff Combo", icon: spellIcons.QSTAFF_COMBO },
      { name: "Stun Run", icon: spellIcons.STUNRUN },
      { name: "Qs Whirlwind 2", icon: spellIcons.QS_WHIRLWIND2 },
      { name: "Launcher", icon: spellIcons.LAUNCHER },
      { name: "Separating Slam", icon: spellIcons.SEPARATING_SLAM },
    ],
    active3: [{ name: "Qs Slowrope", icon: spellIcons.QS_SLOWROPE }],
    passive1: [
      {
        name: "Passive Stun Chance Quarterstaff",
        icon: spellIcons.PASSIVE_STUNCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Energy Chance Quarterstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Health Chance Quarterstaff",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive CC Duration Chance Quarterstaff",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_QUARTERSTAFF,
      },
    ],
  },

  T8_2H_QUARTERSTAFF_AVALON: {
    active1: [
      {
        name: "Concussive Blow Multi 1",
        icon: spellIcons.CONCUSSIVEBLOW_MULTI_1,
      },
      { name: "Whirling Staff", icon: spellIcons.WHIRLING_STAFF },
      { name: "Cartwheel", icon: spellIcons.CARTWHEEL },
    ],
    active2: [
      { name: "Qstaff Combo", icon: spellIcons.QSTAFF_COMBO },
      { name: "Stun Run", icon: spellIcons.STUNRUN },
      { name: "Qs Whirlwind 2", icon: spellIcons.QS_WHIRLWIND2 },
      { name: "Launcher", icon: spellIcons.LAUNCHER },
      { name: "Separating Slam", icon: spellIcons.SEPARATING_SLAM },
    ],
    active3: [{ name: "Soul Shaker", icon: spellIcons.SOULSHAKER }],
    passive1: [
      {
        name: "Passive Stun Chance Quarterstaff",
        icon: spellIcons.PASSIVE_STUNCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Energy Chance Quarterstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Health Chance Quarterstaff",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive CC Duration Chance Quarterstaff",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_QUARTERSTAFF,
      },
    ],
  },
  T8_2H_DOUBLEBLADEDSTAFF_CRYSTAL: {
    active1: [
      {
        name: "Concussive Blow Multi 1",
        icon: spellIcons.CONCUSSIVEBLOW_MULTI_1,
      },
      { name: "Whirling Staff", icon: spellIcons.WHIRLING_STAFF },
      { name: "Cartwheel", icon: spellIcons.CARTWHEEL },
    ],
    active2: [
      { name: "Qstaff Combo", icon: spellIcons.QSTAFF_COMBO },
      { name: "Stun Run", icon: spellIcons.STUNRUN },
      { name: "Qs Whirlwind 2", icon: spellIcons.QS_WHIRLWIND2 },
      { name: "Launcher", icon: spellIcons.LAUNCHER },
      { name: "Separating Slam", icon: spellIcons.SEPARATING_SLAM },
    ],
    active3: [{ name: "Qs Crystal Combo", icon: spellIcons.QS_CRYSTAL_COMBO }],
    passive1: [
      {
        name: "Passive Stun Chance Quarterstaff",
        icon: spellIcons.PASSIVE_STUNCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Energy Chance Quarterstaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive Health Chance Quarterstaff",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_QUARTERSTAFF,
      },
      {
        name: "Passive CC Duration Chance Quarterstaff",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_QUARTERSTAFF,
      },
    ],
  },

  T8_2H_SHAPESHIFTER_SET1: {
    active1: [
      { name: "Shape Q Cast", icon: spellIcons.SHAPE_Q_CAST },
      { name: "Shape Q Skillshot", icon: spellIcons.SHAPE_Q_SKILLSHOT },
      {
        name: "Shape Q Damage and Shield",
        icon: spellIcons.SHAPE_Q_DAMAGE_AND_SHIELD,
      },
      { name: "Shape Q Cone Melee", icon: spellIcons.SHAPE_Q_CONE_MELEE },
    ],
    active2: [
      { name: "Shape W Damage AoE", icon: spellIcons.SHAPE_W_DAMAGE_AOE },
      { name: "Shape W Area Pull", icon: spellIcons.SHAPE_W_AREA_PULL },
      { name: "Shape W Tether Beam", icon: spellIcons.SHAPE_W_TETHERBEAM },
      { name: "Shape W Polymorph", icon: spellIcons.SHAPE_W_POLYMORPH },
    ],
    active3: [
      { name: "Shapeshift Panther", icon: spellIcons.SHAPESHIFT_PANTHER },
    ],
    passive1: [
      {
        name: "Passive Shapeshift Attack Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_ATTACK_BUFF,
      },
      {
        name: "Passive Shapeshift Q Cast Damage Reduce",
        icon: spellIcons.PASSIVE_SHAPESHIFT_Q_CAST_DAMAGE_REDUCE,
      },
      {
        name: "Passive Shapeshift Gather Charges",
        icon: spellIcons.PASSIVE_SHAPESHIFT_GATHER_CHARGES,
      },
      {
        name: "Passive Shapeshift W Cast Speed Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_W_CAST_SPEED_BUFF,
      },
    ],
  },

  T8_2H_SHAPESHIFTER_SET2: {
    active1: [
      { name: "Shape Q Cast", icon: spellIcons.SHAPE_Q_CAST },
      { name: "Shape Q Skillshot", icon: spellIcons.SHAPE_Q_SKILLSHOT },
      {
        name: "Shape Q Damage and Shield",
        icon: spellIcons.SHAPE_Q_DAMAGE_AND_SHIELD,
      },
      { name: "Shape Q Cone Melee", icon: spellIcons.SHAPE_Q_CONE_MELEE },
    ],
    active2: [
      { name: "Shape W Damage AoE", icon: spellIcons.SHAPE_W_DAMAGE_AOE },
      { name: "Shape W Area Pull", icon: spellIcons.SHAPE_W_AREA_PULL },
      { name: "Shape W Tether Beam", icon: spellIcons.SHAPE_W_TETHERBEAM },
      { name: "Shape W Polymorph", icon: spellIcons.SHAPE_W_POLYMORPH },
    ],
    active3: [{ name: "Shapeshift Ent", icon: spellIcons.SHAPESHIFT_ENT }],
    passive1: [
      {
        name: "Passive Shapeshift Attack Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_ATTACK_BUFF,
      },
      {
        name: "Passive Shapeshift Q Cast Damage Reduce",
        icon: spellIcons.PASSIVE_SHAPESHIFT_Q_CAST_DAMAGE_REDUCE,
      },
      {
        name: "Passive Shapeshift Gather Charges",
        icon: spellIcons.PASSIVE_SHAPESHIFT_GATHER_CHARGES,
      },
      {
        name: "Passive Shapeshift W Cast Speed Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_W_CAST_SPEED_BUFF,
      },
    ],
  },

  T8_2H_SHAPESHIFTER_SET3: {
    active1: [
      { name: "Shape Q Cast", icon: spellIcons.SHAPE_Q_CAST },
      { name: "Shape Q Skillshot", icon: spellIcons.SHAPE_Q_SKILLSHOT },
      {
        name: "Shape Q Damage and Shield",
        icon: spellIcons.SHAPE_Q_DAMAGE_AND_SHIELD,
      },
      { name: "Shape Q Cone Melee", icon: spellIcons.SHAPE_Q_CONE_MELEE },
    ],
    active2: [
      { name: "Shape W Damage AoE", icon: spellIcons.SHAPE_W_DAMAGE_AOE },
      { name: "Shape W Area Pull", icon: spellIcons.SHAPE_W_AREA_PULL },
      { name: "Shape W Tether Beam", icon: spellIcons.SHAPE_W_TETHERBEAM },
      { name: "Shape W Polymorph", icon: spellIcons.SHAPE_W_POLYMORPH },
    ],
    active3: [{ name: "Shapeshift Bear", icon: spellIcons.SHAPESHIFT_BEAR }],
    passive1: [
      {
        name: "Passive Shapeshift Attack Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_ATTACK_BUFF,
      },
      {
        name: "Passive Shapeshift Q Cast Damage Reduce",
        icon: spellIcons.PASSIVE_SHAPESHIFT_Q_CAST_DAMAGE_REDUCE,
      },
      {
        name: "Passive Shapeshift Gather Charges",
        icon: spellIcons.PASSIVE_SHAPESHIFT_GATHER_CHARGES,
      },
      {
        name: "Passive Shapeshift W Cast Speed Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_W_CAST_SPEED_BUFF,
      },
    ],
  },

  T8_2H_SHAPESHIFTER_MORGANA: {
    active1: [
      { name: "Shape Q Cast", icon: spellIcons.SHAPE_Q_CAST },
      { name: "Shape Q Skillshot", icon: spellIcons.SHAPE_Q_SKILLSHOT },
      {
        name: "Shape Q Damage and Shield",
        icon: spellIcons.SHAPE_Q_DAMAGE_AND_SHIELD,
      },
      { name: "Shape Q Cone Melee", icon: spellIcons.SHAPE_Q_CONE_MELEE },
    ],
    active2: [
      { name: "Shape W Damage AoE", icon: spellIcons.SHAPE_W_DAMAGE_AOE },
      { name: "Shape W Area Pull", icon: spellIcons.SHAPE_W_AREA_PULL },
      { name: "Shape W Tether Beam", icon: spellIcons.SHAPE_W_TETHERBEAM },
      { name: "Shape W Polymorph", icon: spellIcons.SHAPE_W_POLYMORPH },
    ],
    active3: [
      { name: "Shapeshift Werewolf", icon: spellIcons.SHAPESHIFT_WEREWOLF },
    ],
    passive1: [
      {
        name: "Passive Shapeshift Attack Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_ATTACK_BUFF,
      },
      {
        name: "Passive Shapeshift Q Cast Damage Reduce",
        icon: spellIcons.PASSIVE_SHAPESHIFT_Q_CAST_DAMAGE_REDUCE,
      },
      {
        name: "Passive Shapeshift Gather Charges",
        icon: spellIcons.PASSIVE_SHAPESHIFT_GATHER_CHARGES,
      },
      {
        name: "Passive Shapeshift W Cast Speed Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_W_CAST_SPEED_BUFF,
      },
    ],
  },

  T8_2H_SHAPESHIFTER_HELL: {
    active1: [
      { name: "Shape Q Cast", icon: spellIcons.SHAPE_Q_CAST },
      { name: "Shape Q Skillshot", icon: spellIcons.SHAPE_Q_SKILLSHOT },
      {
        name: "Shape Q Damage and Shield",
        icon: spellIcons.SHAPE_Q_DAMAGE_AND_SHIELD,
      },
      { name: "Shape Q Cone Melee", icon: spellIcons.SHAPE_Q_CONE_MELEE },
    ],
    active2: [
      { name: "Shape W Damage AoE", icon: spellIcons.SHAPE_W_DAMAGE_AOE },
      { name: "Shape W Area Pull", icon: spellIcons.SHAPE_W_AREA_PULL },
      { name: "Shape W Tether Beam", icon: spellIcons.SHAPE_W_TETHERBEAM },
      { name: "Shape W Polymorph", icon: spellIcons.SHAPE_W_POLYMORPH },
    ],
    active3: [{ name: "Shapeshift Imp", icon: spellIcons.SHAPESHIFT_IMP }],
    passive1: [
      {
        name: "Passive Shapeshift Attack Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_ATTACK_BUFF,
      },
      {
        name: "Passive Shapeshift Q Cast Damage Reduce",
        icon: spellIcons.PASSIVE_SHAPESHIFT_Q_CAST_DAMAGE_REDUCE,
      },
      {
        name: "Passive Shapeshift Gather Charges",
        icon: spellIcons.PASSIVE_SHAPESHIFT_GATHER_CHARGES,
      },
      {
        name: "Passive Shapeshift W Cast Speed Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_W_CAST_SPEED_BUFF,
      },
    ],
  },

  T8_2H_SHAPESHIFTER_KEEPER: {
    active1: [
      { name: "Shape Q Cast", icon: spellIcons.SHAPE_Q_CAST },
      { name: "Shape Q Skillshot", icon: spellIcons.SHAPE_Q_SKILLSHOT },
      {
        name: "Shape Q Damage and Shield",
        icon: spellIcons.SHAPE_Q_DAMAGE_AND_SHIELD,
      },
      { name: "Shape Q Cone Melee", icon: spellIcons.SHAPE_Q_CONE_MELEE },
    ],
    active2: [
      { name: "Shape W Damage AoE", icon: spellIcons.SHAPE_W_DAMAGE_AOE },
      { name: "Shape W Area Pull", icon: spellIcons.SHAPE_W_AREA_PULL },
      { name: "Shape W Tether Beam", icon: spellIcons.SHAPE_W_TETHERBEAM },
      { name: "Shape W Polymorph", icon: spellIcons.SHAPE_W_POLYMORPH },
    ],
    active3: [
      {
        name: "Shapeshift Rock Elemental",
        icon: spellIcons.SHAPESHIFT_ROCK_ELEMENTAL,
      },
    ],
    passive1: [
      {
        name: "Passive Shapeshift Attack Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_ATTACK_BUFF,
      },
      {
        name: "Passive Shapeshift Q Cast Damage Reduce",
        icon: spellIcons.PASSIVE_SHAPESHIFT_Q_CAST_DAMAGE_REDUCE,
      },
      {
        name: "Passive Shapeshift Gather Charges",
        icon: spellIcons.PASSIVE_SHAPESHIFT_GATHER_CHARGES,
      },
      {
        name: "Passive Shapeshift W Cast Speed Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_W_CAST_SPEED_BUFF,
      },
    ],
  },

  T8_2H_SHAPESHIFTER_AVALON: {
    active1: [
      { name: "Shape Q Cast", icon: spellIcons.SHAPE_Q_CAST },
      { name: "Shape Q Skillshot", icon: spellIcons.SHAPE_Q_SKILLSHOT },
      {
        name: "Shape Q Damage and Shield",
        icon: spellIcons.SHAPE_Q_DAMAGE_AND_SHIELD,
      },
      { name: "Shape Q Cone Melee", icon: spellIcons.SHAPE_Q_CONE_MELEE },
    ],
    active2: [
      { name: "Shape W Damage AoE", icon: spellIcons.SHAPE_W_DAMAGE_AOE },
      { name: "Shape W Area Pull", icon: spellIcons.SHAPE_W_AREA_PULL },
      { name: "Shape W Tether Beam", icon: spellIcons.SHAPE_W_TETHERBEAM },
      { name: "Shape W Polymorph", icon: spellIcons.SHAPE_W_POLYMORPH },
    ],
    active3: [
      {
        name: "Shapeshift Avalonian Eagle",
        icon: spellIcons.SHAPESHIFT_AVALONIAN_EAGLE,
      },
    ],
    passive1: [
      {
        name: "Passive Shapeshift Attack Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_ATTACK_BUFF,
      },
      {
        name: "Passive Shapeshift Q Cast Damage Reduce",
        icon: spellIcons.PASSIVE_SHAPESHIFT_Q_CAST_DAMAGE_REDUCE,
      },
      {
        name: "Passive Shapeshift Gather Charges",
        icon: spellIcons.PASSIVE_SHAPESHIFT_GATHER_CHARGES,
      },
      {
        name: "Passive Shapeshift W Cast Speed Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_W_CAST_SPEED_BUFF,
      },
    ],
  },

  T8_2H_SHAPESHIFTER_CRYSTAL: {
    active1: [
      { name: "Shape Q Cast", icon: spellIcons.SHAPE_Q_CAST },
      { name: "Shape Q Skillshot", icon: spellIcons.SHAPE_Q_SKILLSHOT },
      {
        name: "Shape Q Damage and Shield",
        icon: spellIcons.SHAPE_Q_DAMAGE_AND_SHIELD,
      },
      { name: "Shape Q Cone Melee", icon: spellIcons.SHAPE_Q_CONE_MELEE },
    ],
    active2: [
      { name: "Shape W Damage AoE", icon: spellIcons.SHAPE_W_DAMAGE_AOE },
      { name: "Shape W Area Pull", icon: spellIcons.SHAPE_W_AREA_PULL },
      { name: "Shape W Tether Beam", icon: spellIcons.SHAPE_W_TETHERBEAM },
      { name: "Shape W Polymorph", icon: spellIcons.SHAPE_W_POLYMORPH },
    ],
    active3: [
      {
        name: "Crystal Cobra Transformation",
        icon: spellIcons.CrystalCobraTransformation,
      },
    ],
    passive1: [
      {
        name: "Passive Shapeshift Attack Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_ATTACK_BUFF,
      },
      {
        name: "Passive Shapeshift Q Cast Damage Reduce",
        icon: spellIcons.PASSIVE_SHAPESHIFT_Q_CAST_DAMAGE_REDUCE,
      },
      {
        name: "Passive Shapeshift Gather Charges",
        icon: spellIcons.PASSIVE_SHAPESHIFT_GATHER_CHARGES,
      },
      {
        name: "Passive Shapeshift W Cast Speed Buff",
        icon: spellIcons.PASSIVE_SHAPESHIFT_W_CAST_SPEED_BUFF,
      },
    ],
  },

  T8_MAIN_NATURESTAFF: {
    active1: [
      { name: "Rejuvenation", icon: spellIcons.REJUVENATION },
      { name: "Thorns Area", icon: spellIcons.THORNSAREA },
      {
        name: "Rejuv Mushroom Grenade",
        icon: spellIcons.REJUVMUSHROOM_GRENADE,
      },
    ],
    active2: [
      { name: "Bramble Seed", icon: spellIcons.BRAMBLESEED },
      { name: "Reanimate", icon: spellIcons.REANIMATE },
      { name: "Nature Resilience", icon: spellIcons.NATURERESILIENCE },
      { name: "Cleanse Heal", icon: spellIcons.CLEANSEHEAL },
      { name: "Rejuvenating Breeze", icon: spellIcons.REJUVENATING_BREEZE },
    ],
    active3: [{ name: "Circle of Life", icon: spellIcons.CIRCLEOFLIFE }],
    passive1: [
      {
        name: "Passive Healpower Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energychance Naturestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_NATURESTAFF,
      },
      {
        name: "Passive Armor Caster Naturestaff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_NATURESTAFF,
      },
      {
        name: "Passive Movespeed Chance Naturestaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_NATURESTAFF,
      },
    ],
  },

  T8_2H_NATURESTAFF: {
    active1: [
      { name: "Rejuvenation", icon: spellIcons.REJUVENATION },
      { name: "Thorns Area", icon: spellIcons.THORNSAREA },
      {
        name: "Rejuv Mushroom Grenade",
        icon: spellIcons.REJUVMUSHROOM_GRENADE,
      },
    ],
    active2: [
      { name: "Bramble Seed", icon: spellIcons.BRAMBLESEED },
      { name: "Reanimate", icon: spellIcons.REANIMATE },
      { name: "Nature Resilience", icon: spellIcons.NATURERESILIENCE },
      { name: "Cleanse Heal", icon: spellIcons.CLEANSEHEAL },
      { name: "Rejuvenating Breeze", icon: spellIcons.REJUVENATING_BREEZE },
    ],
    active3: [{ name: "Brier of Life", icon: spellIcons.BRIEROFLIFE }],
    passive1: [
      {
        name: "Passive Healpower Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energychance Naturestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_NATURESTAFF,
      },
      {
        name: "Passive Armor Caster Naturestaff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_NATURESTAFF,
      },
      {
        name: "Passive Movespeed Chance Naturestaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_NATURESTAFF,
      },
    ],
  },

  T8_2H_WILDSTAFF: {
    active1: [
      { name: "Rejuvenation", icon: spellIcons.REJUVENATION },
      { name: "Thorns Area", icon: spellIcons.THORNSAREA },
      {
        name: "Rejuv Mushroom Grenade",
        icon: spellIcons.REJUVMUSHROOM_GRENADE,
      },
    ],
    active2: [
      { name: "Bramble Seed", icon: spellIcons.BRAMBLESEED },
      { name: "Reanimate", icon: spellIcons.REANIMATE },
      { name: "Nature Resilience", icon: spellIcons.NATURERESILIENCE },
      { name: "Cleanse Heal", icon: spellIcons.CLEANSEHEAL },
      { name: "Rejuvenating Breeze", icon: spellIcons.REJUVENATING_BREEZE },
    ],
    active3: [{ name: "Well of Life 2", icon: spellIcons.WELLOFLIFE2 }],
    passive1: [
      {
        name: "Passive Healpower Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energychance Naturestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_NATURESTAFF,
      },
      {
        name: "Passive Armor Caster Naturestaff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_NATURESTAFF,
      },
      {
        name: "Passive Movespeed Chance Naturestaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_NATURESTAFF,
      },
    ],
  },

  T8_MAIN_NATURESTAFF_KEEPER: {
    active1: [
      { name: "Rejuvenation", icon: spellIcons.REJUVENATION },
      { name: "Thorns Area", icon: spellIcons.THORNSAREA },
      {
        name: "Rejuv Mushroom Grenade",
        icon: spellIcons.REJUVMUSHROOM_GRENADE,
      },
    ],
    active2: [
      { name: "Bramble Seed", icon: spellIcons.BRAMBLESEED },
      { name: "Reanimate", icon: spellIcons.REANIMATE },
      { name: "Nature Resilience", icon: spellIcons.NATURERESILIENCE },
      { name: "Cleanse Heal", icon: spellIcons.CLEANSEHEAL },
      { name: "Rejuvenating Breeze", icon: spellIcons.REJUVENATING_BREEZE },
    ],
    active3: [
      {
        name: "Nature Ultimate Single",
        icon: spellIcons.NATURE_ULTIMATE_SINGLE,
      },
    ],
    passive1: [
      {
        name: "Passive Healpower Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energychance Naturestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_NATURESTAFF,
      },
      {
        name: "Passive Armor Caster Naturestaff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_NATURESTAFF,
      },
      {
        name: "Passive Movespeed Chance Naturestaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_NATURESTAFF,
      },
    ],
  },

  T8_2H_NATURESTAFF_HELL: {
    active1: [
      { name: "Rejuvenation", icon: spellIcons.REJUVENATION },
      { name: "Thorns Area", icon: spellIcons.THORNSAREA },
      {
        name: "Rejuv Mushroom Grenade",
        icon: spellIcons.REJUVMUSHROOM_GRENADE,
      },
    ],
    active2: [
      { name: "Bramble Seed", icon: spellIcons.BRAMBLESEED },
      { name: "Reanimate", icon: spellIcons.REANIMATE },
      { name: "Nature Resilience", icon: spellIcons.NATURERESILIENCE },
      { name: "Cleanse Heal", icon: spellIcons.CLEANSEHEAL },
      { name: "Rejuvenating Breeze", icon: spellIcons.REJUVENATING_BREEZE },
    ],
    active3: [{ name: "Rotten Vines", icon: spellIcons.ROTTENVINES }],
    passive1: [
      {
        name: "Passive Healpower Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energychance Naturestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_NATURESTAFF,
      },
      {
        name: "Passive Armor Caster Naturestaff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_NATURESTAFF,
      },
      {
        name: "Passive Movespeed Chance Naturestaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_NATURESTAFF,
      },
    ],
  },

  T8_2H_NATURESTAFF_KEEPER: {
    active1: [
      { name: "Rejuvenation", icon: spellIcons.REJUVENATION },
      { name: "Thorns Area", icon: spellIcons.THORNSAREA },
      {
        name: "Rejuv Mushroom Grenade",
        icon: spellIcons.REJUVMUSHROOM_GRENADE,
      },
    ],
    active2: [
      { name: "Bramble Seed", icon: spellIcons.BRAMBLESEED },
      { name: "Reanimate", icon: spellIcons.REANIMATE },
      { name: "Nature Resilience", icon: spellIcons.NATURERESILIENCE },
      { name: "Cleanse Heal", icon: spellIcons.CLEANSEHEAL },
      { name: "Rejuvenating Breeze", icon: spellIcons.REJUVENATING_BREEZE },
    ],
    active3: [{ name: "Spirit Animal", icon: spellIcons.SPIRITANIMAL }],
    passive1: [
      {
        name: "Passive Healpower Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energychance Naturestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_NATURESTAFF,
      },
      {
        name: "Passive Armor Caster Naturestaff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_NATURESTAFF,
      },
      {
        name: "Passive Movespeed Chance Naturestaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_NATURESTAFF,
      },
    ],
  },

  T8_MAIN_NATURESTAFF_AVALON: {
    active1: [
      { name: "Rejuvenation", icon: spellIcons.REJUVENATION },
      { name: "Thorns Area", icon: spellIcons.THORNSAREA },
      {
        name: "Rejuv Mushroom Grenade",
        icon: spellIcons.REJUVMUSHROOM_GRENADE,
      },
    ],
    active2: [
      { name: "Bramble Seed", icon: spellIcons.BRAMBLESEED },
      { name: "Reanimate", icon: spellIcons.REANIMATE },
      { name: "Nature Resilience", icon: spellIcons.NATURERESILIENCE },
      { name: "Cleanse Heal", icon: spellIcons.CLEANSEHEAL },
      { name: "Rejuvenating Breeze", icon: spellIcons.REJUVENATING_BREEZE },
    ],
    active3: [{ name: "Soul Link", icon: spellIcons.SOUL_LINK }],
    passive1: [
      {
        name: "Passive Healpower Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energychance Naturestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_NATURESTAFF,
      },
      {
        name: "Passive Armor Caster Naturestaff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_NATURESTAFF,
      },
      {
        name: "Passive Movespeed Chance Naturestaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_NATURESTAFF,
      },
    ],
  },

  T8_MAIN_NATURESTAFF_CRYSTAL: {
    active1: [
      { name: "Rejuvenation", icon: spellIcons.REJUVENATION },
      { name: "Thorns Area", icon: spellIcons.THORNSAREA },
      {
        name: "Rejuv Mushroom Grenade",
        icon: spellIcons.REJUVMUSHROOM_GRENADE,
      },
    ],
    active2: [
      { name: "Bramble Seed", icon: spellIcons.BRAMBLESEED },
      { name: "Reanimate", icon: spellIcons.REANIMATE },
      { name: "Nature Resilience", icon: spellIcons.NATURERESILIENCE },
      { name: "Cleanse Heal", icon: spellIcons.CLEANSEHEAL },
      { name: "Rejuvenating Breeze", icon: spellIcons.REJUVENATING_BREEZE },
    ],
    active3: [{ name: "Dual Nature", icon: spellIcons.DUAL_NATURE }],
    passive1: [
      {
        name: "Passive Healpower Chance",
        icon: spellIcons.PASSIVE_HEALPOWERCHANCE,
      },
      {
        name: "Passive Energychance Naturestaff",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_NATURESTAFF,
      },
      {
        name: "Passive Armor Caster Naturestaff",
        icon: spellIcons.PASSIVE_ARMOR_CASTER_NATURESTAFF,
      },
      {
        name: "Passive Movespeed Chance Naturestaff",
        icon: spellIcons.PASSIVE_MOVESPEED_CHANCE_NATURESTAFF,
      },
    ],
  },

  T8_MAIN_SWORD: {
    active1: [
      { name: "Heroic Strike 2", icon: spellIcons.HEROICSTRIKE2 },
      { name: "Cleave", icon: spellIcons.CLEAVE },
    ],
    active2: [
      { name: "Sword Spin", icon: spellIcons.SWORD_SPIN },
      { name: "Interrupt 2", icon: spellIcons.INTERRUPT2 },
      { name: "Splitting Slash", icon: spellIcons.SPLITTINGSLASH },
      { name: "Hamstring Sword", icon: spellIcons.HAMSTRINGSWORD },
      { name: "Parry", icon: spellIcons.PARRY },
      { name: "Defense Run", icon: spellIcons.DEFENSERUN },
    ],
    active3: [{ name: "Mighty Blow", icon: spellIcons.MIGHTYBLOW }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Reduce Dmg Sword",
        icon: spellIcons.PASSIVE_REDUCE_DMG_SWORD,
      },
      { name: "Passive Heroicstack", icon: spellIcons.PASSIVE_HEROICSTACK },
      {
        name: "Passive Armorchance Sword",
        icon: spellIcons.PASSIVE_ARMORCHANCE_SWORD,
      },
    ],
  },

  T8_2H_CLAYMORE: {
    active1: [
      { name: "Heroic Strike 2", icon: spellIcons.HEROICSTRIKE2 },
      { name: "Cleave", icon: spellIcons.CLEAVE },
    ],
    active2: [
      { name: "Sword Spin", icon: spellIcons.SWORD_SPIN },
      { name: "Interrupt 2", icon: spellIcons.INTERRUPT2 },
      { name: "Splitting Slash", icon: spellIcons.SPLITTINGSLASH },
      { name: "Hamstring Sword", icon: spellIcons.HAMSTRINGSWORD },
      { name: "Parry", icon: spellIcons.PARRY },
      { name: "Defense Run", icon: spellIcons.DEFENSERUN },
    ],
    active3: [{ name: "Claymore Charge", icon: spellIcons.CLAYMORECHARGE }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Reduce Dmg Sword",
        icon: spellIcons.PASSIVE_REDUCE_DMG_SWORD,
      },
      { name: "Passive Heroicstack", icon: spellIcons.PASSIVE_HEROICSTACK },
      {
        name: "Passive Armorchance Sword",
        icon: spellIcons.PASSIVE_ARMORCHANCE_SWORD,
      },
    ],
  },

  T8_2H_DUALSWORD: {
    active1: [
      { name: "Heroic Strike 2", icon: spellIcons.HEROICSTRIKE2 },
      { name: "Cleave", icon: spellIcons.CLEAVE },
    ],
    active2: [
      { name: "Sword Spin", icon: spellIcons.SWORD_SPIN },
      { name: "Interrupt 2", icon: spellIcons.INTERRUPT2 },
      { name: "Splitting Slash", icon: spellIcons.SPLITTINGSLASH },
      { name: "Hamstring Sword", icon: spellIcons.HAMSTRINGSWORD },
      { name: "Parry", icon: spellIcons.PARRY },
      { name: "Defense Run", icon: spellIcons.DEFENSERUN },
    ],
    active3: [{ name: "Spin Attack", icon: spellIcons.SPINATTACK }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Reduce Dmg Sword",
        icon: spellIcons.PASSIVE_REDUCE_DMG_SWORD,
      },
      { name: "Passive Heroicstack", icon: spellIcons.PASSIVE_HEROICSTACK },
      {
        name: "Passive Armorchance Sword",
        icon: spellIcons.PASSIVE_ARMORCHANCE_SWORD,
      },
    ],
  },

  T8_MAIN_SCIMITAR_MORGANA: {
    active1: [
      { name: "Heroic Strike 2", icon: spellIcons.HEROICSTRIKE2 },
      { name: "Cleave", icon: spellIcons.CLEAVE },
    ],
    active2: [
      { name: "Sword Spin", icon: spellIcons.SWORD_SPIN },
      { name: "Interrupt 2", icon: spellIcons.INTERRUPT2 },
      { name: "Splitting Slash", icon: spellIcons.SPLITTINGSLASH },
      { name: "Hamstring Sword", icon: spellIcons.HAMSTRINGSWORD },
      { name: "Parry", icon: spellIcons.PARRY },
      { name: "Defense Run", icon: spellIcons.DEFENSERUN },
    ],
    active3: [{ name: "Mighty Swing", icon: spellIcons.MIGHTYSWING }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Reduce Dmg Sword",
        icon: spellIcons.PASSIVE_REDUCE_DMG_SWORD,
      },
      { name: "Passive Heroicstack", icon: spellIcons.PASSIVE_HEROICSTACK },
      {
        name: "Passive Armorchance Sword",
        icon: spellIcons.PASSIVE_ARMORCHANCE_SWORD,
      },
    ],
  },

  T8_2H_CLEAVER_HELL: {
    active1: [
      { name: "Heroic Strike 2", icon: spellIcons.HEROICSTRIKE2 },
      { name: "Cleave", icon: spellIcons.CLEAVE },
    ],
    active2: [
      { name: "Sword Spin", icon: spellIcons.SWORD_SPIN },
      { name: "Interrupt 2", icon: spellIcons.INTERRUPT2 },
      { name: "Splitting Slash", icon: spellIcons.SPLITTINGSLASH },
      { name: "Hamstring Sword", icon: spellIcons.HAMSTRINGSWORD },
      { name: "Parry", icon: spellIcons.PARRY },
      { name: "Defense Run", icon: spellIcons.DEFENSERUN },
    ],
    active3: [{ name: "Claymore Slash", icon: spellIcons.CLAYMORESLASH }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Reduce Dmg Sword",
        icon: spellIcons.PASSIVE_REDUCE_DMG_SWORD,
      },
      { name: "Passive Heroicstack", icon: spellIcons.PASSIVE_HEROICSTACK },
      {
        name: "Passive Armorchance Sword",
        icon: spellIcons.PASSIVE_ARMORCHANCE_SWORD,
      },
    ],
  },

  T8_2H_DUALSCIMITAR_UNDEAD: {
    active1: [
      { name: "Heroic Strike 2", icon: spellIcons.HEROICSTRIKE2 },
      { name: "Cleave", icon: spellIcons.CLEAVE },
    ],
    active2: [
      { name: "Sword Spin", icon: spellIcons.SWORD_SPIN },
      { name: "Interrupt 2", icon: spellIcons.INTERRUPT2 },
      { name: "Splitting Slash", icon: spellIcons.SPLITTINGSLASH },
      { name: "Hamstring Sword", icon: spellIcons.HAMSTRINGSWORD },
      { name: "Parry", icon: spellIcons.PARRY },
      { name: "Defense Run", icon: spellIcons.DEFENSERUN },
    ],
    active3: [{ name: "Blade Area", icon: spellIcons.BLADE_AREA }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Reduce Dmg Sword",
        icon: spellIcons.PASSIVE_REDUCE_DMG_SWORD,
      },
      { name: "Passive Heroicstack", icon: spellIcons.PASSIVE_HEROICSTACK },
      {
        name: "Passive Armorchance Sword",
        icon: spellIcons.PASSIVE_ARMORCHANCE_SWORD,
      },
    ],
  },

  T8_2H_CLAYMORE_AVALON: {
    active1: [
      { name: "Heroic Strike 2", icon: spellIcons.HEROICSTRIKE2 },
      { name: "Cleave", icon: spellIcons.CLEAVE },
    ],
    active2: [
      { name: "Sword Spin", icon: spellIcons.SWORD_SPIN },
      { name: "Interrupt 2", icon: spellIcons.INTERRUPT2 },
      { name: "Splitting Slash", icon: spellIcons.SPLITTINGSLASH },
      { name: "Hamstring Sword", icon: spellIcons.HAMSTRINGSWORD },
      { name: "Parry", icon: spellIcons.PARRY },
      { name: "Defense Run", icon: spellIcons.DEFENSERUN },
    ],
    active3: [{ name: "Majestic Smash", icon: spellIcons.MAJESTIC_SMASH }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Reduce Dmg Sword",
        icon: spellIcons.PASSIVE_REDUCE_DMG_SWORD,
      },
      { name: "Passive Heroicstack", icon: spellIcons.PASSIVE_HEROICSTACK },
      {
        name: "Passive Armorchance Sword",
        icon: spellIcons.PASSIVE_ARMORCHANCE_SWORD,
      },
    ],
  },

  T8_MAIN_SWORD_CRYSTAL: {
    active1: [
      { name: "Heroic Strike 2", icon: spellIcons.HEROICSTRIKE2 },
      { name: "Cleave", icon: spellIcons.CLEAVE },
    ],
    active2: [
      { name: "Sword Spin", icon: spellIcons.SWORD_SPIN },
      { name: "Interrupt 2", icon: spellIcons.INTERRUPT2 },
      { name: "Splitting Slash", icon: spellIcons.SPLITTINGSLASH },
      { name: "Hamstring Sword", icon: spellIcons.HAMSTRINGSWORD },
      { name: "Parry", icon: spellIcons.PARRY },
      { name: "Defense Run", icon: spellIcons.DEFENSERUN },
    ],
    active3: [
      { name: "Sword Berserk Run Re", icon: spellIcons.SWORD_BERSERK_RUN_RE },
    ],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Reduce Dmg Sword",
        icon: spellIcons.PASSIVE_REDUCE_DMG_SWORD,
      },
      { name: "Passive Heroicstack", icon: spellIcons.PASSIVE_HEROICSTACK },
      {
        name: "Passive Armorchance Sword",
        icon: spellIcons.PASSIVE_ARMORCHANCE_SWORD,
      },
    ],
  },

  T8_MAIN_AXE: {
    active1: [
      { name: "Rending Strike", icon: spellIcons.RENDINGSTRIKE },
      { name: "Rending Spin", icon: spellIcons.RENDINGSPIN },
      { name: "Rending Combo", icon: spellIcons.RENDINGCOMBO },
    ],
    active2: [
      { name: "Axe Smash", icon: spellIcons.AXESMASH },
      { name: "Axe Boost", icon: spellIcons.AXEBOOST },
      { name: "Axe Charge", icon: spellIcons.AXE_CHARGE },
      { name: "Inner Bleeding", icon: spellIcons.INNERBLEEDING },
      { name: "Blade Aura", icon: spellIcons.BLADE_AURA },
    ],
    active3: [{ name: "Axe Throw", icon: spellIcons.AXETHROW }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Healthchance Axe",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_AXE,
      },
      {
        name: "Passive Armorchance Axe",
        icon: spellIcons.PASSIVE_ARMORCHANCE_AXE,
      },
      {
        name: "Passive Spellpower Chance Axe",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_AXE,
      },
    ],
  },

  T8_2H_AXE: {
    active1: [
      { name: "Rending Strike", icon: spellIcons.RENDINGSTRIKE },
      { name: "Rending Spin", icon: spellIcons.RENDINGSPIN },
      { name: "Rending Combo", icon: spellIcons.RENDINGCOMBO },
    ],
    active2: [
      { name: "Axe Smash", icon: spellIcons.AXESMASH },
      { name: "Axe Boost", icon: spellIcons.AXEBOOST },
      { name: "Axe Charge", icon: spellIcons.AXE_CHARGE },
      { name: "Inner Bleeding", icon: spellIcons.INNERBLEEDING },
      { name: "Blade Aura", icon: spellIcons.BLADE_AURA },
    ],
    active3: [{ name: "Axe Whirlwind 2", icon: spellIcons.AXEWHIRLWIND2 }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Healthchance Axe",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_AXE,
      },
      {
        name: "Passive Armorchance Axe",
        icon: spellIcons.PASSIVE_ARMORCHANCE_AXE,
      },
      {
        name: "Passive Spellpower Chance Axe",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_AXE,
      },
    ],
  },

  T8_2H_HALBERD: {
    active1: [
      { name: "Rending Strike", icon: spellIcons.RENDINGSTRIKE },
      { name: "Rending Spin", icon: spellIcons.RENDINGSPIN },
      { name: "Rending Combo", icon: spellIcons.RENDINGCOMBO },
    ],
    active2: [
      { name: "Axe Smash", icon: spellIcons.AXESMASH },
      { name: "Axe Boost", icon: spellIcons.AXEBOOST },
      { name: "Axe Charge", icon: spellIcons.AXE_CHARGE },
      { name: "Inner Bleeding", icon: spellIcons.INNERBLEEDING },
      { name: "Blade Aura", icon: spellIcons.BLADE_AURA },
    ],
    active3: [{ name: "Rending Swing", icon: spellIcons.RENDINGSWING }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Healthchance Axe",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_AXE,
      },
      {
        name: "Passive Armorchance Axe",
        icon: spellIcons.PASSIVE_ARMORCHANCE_AXE,
      },
      {
        name: "Passive Spellpower Chance Axe",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_AXE,
      },
    ],
  },

  T8_2H_HALBERD_MORGANA: {
    active1: [
      { name: "Rending Strike", icon: spellIcons.RENDINGSTRIKE },
      { name: "Rending Spin", icon: spellIcons.RENDINGSPIN },
      { name: "Rending Combo", icon: spellIcons.RENDINGCOMBO },
    ],
    active2: [
      { name: "Axe Smash", icon: spellIcons.AXESMASH },
      { name: "Axe Boost", icon: spellIcons.AXEBOOST },
      { name: "Axe Charge", icon: spellIcons.AXE_CHARGE },
      { name: "Inner Bleeding", icon: spellIcons.INNERBLEEDING },
      { name: "Blade Aura", icon: spellIcons.BLADE_AURA },
    ],
    active3: [{ name: "Shockwave", icon: spellIcons.SHOCKWAVE }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Healthchance Axe",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_AXE,
      },
      {
        name: "Passive Armorchance Axe",
        icon: spellIcons.PASSIVE_ARMORCHANCE_AXE,
      },
      {
        name: "Passive Spellpower Chance Axe",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_AXE,
      },
    ],
  },
  T8_2H_SCYTHE_HELL: {
    active1: [
      { name: "Rending Strike", icon: spellIcons.RENDINGSTRIKE },
      { name: "Rending Spin", icon: spellIcons.RENDINGSPIN },
      { name: "Rending Combo", icon: spellIcons.RENDINGCOMBO },
    ],
    active2: [
      { name: "Axe Smash", icon: spellIcons.AXESMASH },
      { name: "Axe Boost", icon: spellIcons.AXEBOOST },
      { name: "Axe Charge", icon: spellIcons.AXE_CHARGE },
      { name: "Inner Bleeding", icon: spellIcons.INNERBLEEDING },
      { name: "Blade Aura", icon: spellIcons.BLADE_AURA },
    ],
    active3: [{ name: "Scythe Swing", icon: spellIcons.SCYTHESWING }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Healthchance Axe",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_AXE,
      },
      {
        name: "Passive Armorchance Axe",
        icon: spellIcons.PASSIVE_ARMORCHANCE_AXE,
      },
      {
        name: "Passive Spellpower Chance Axe",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_AXE,
      },
    ],
  },

  T8_2H_DUALAXE_KEEPER: {
    active1: [
      { name: "Rending Strike", icon: spellIcons.RENDINGSTRIKE },
      { name: "Rending Spin", icon: spellIcons.RENDINGSPIN },
      { name: "Rending Combo", icon: spellIcons.RENDINGCOMBO },
    ],
    active2: [
      { name: "Axe Smash", icon: spellIcons.AXESMASH },
      { name: "Axe Boost", icon: spellIcons.AXEBOOST },
      { name: "Axe Charge", icon: spellIcons.AXE_CHARGE },
      { name: "Inner Bleeding", icon: spellIcons.INNERBLEEDING },
      { name: "Blade Aura", icon: spellIcons.BLADE_AURA },
    ],
    active3: [{ name: "Dualaxe Crawler", icon: spellIcons.DUALAXE_CRAWLER }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Healthchance Axe",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_AXE,
      },
      {
        name: "Passive Armorchance Axe",
        icon: spellIcons.PASSIVE_ARMORCHANCE_AXE,
      },
      {
        name: "Passive Spellpower Chance Axe",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_AXE,
      },
    ],
  },
  T8_2H_AXE_AVALON: {
    active1: [
      { name: "Rending Strike", icon: spellIcons.RENDINGSTRIKE },
      { name: "Rending Spin", icon: spellIcons.RENDINGSPIN },
      { name: "Rending Combo", icon: spellIcons.RENDINGCOMBO },
    ],
    active2: [
      { name: "Axe Smash", icon: spellIcons.AXESMASH },
      { name: "Axe Boost", icon: spellIcons.AXEBOOST },
      { name: "Axe Charge", icon: spellIcons.AXE_CHARGE },
      { name: "Inner Bleeding", icon: spellIcons.INNERBLEEDING },
      { name: "Blade Aura", icon: spellIcons.BLADE_AURA },
    ],
    active3: [{ name: "Lethal Cleaver", icon: spellIcons.LETHAL_CLEAVER }],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Healthchance Axe",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_AXE,
      },
      {
        name: "Passive Armorchance Axe",
        icon: spellIcons.PASSIVE_ARMORCHANCE_AXE,
      },
      {
        name: "Passive Spellpower Chance Axe",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_AXE,
      },
    ],
  },
  T8_2H_SCYTHE_CRYSTAL: {
    active1: [
      { name: "Rending Strike", icon: spellIcons.RENDINGSTRIKE },
      { name: "Rending Spin", icon: spellIcons.RENDINGSPIN },
      { name: "Rending Combo", icon: spellIcons.RENDINGCOMBO },
    ],
    active2: [
      { name: "Axe Smash", icon: spellIcons.AXESMASH },
      { name: "Axe Boost", icon: spellIcons.AXEBOOST },
      { name: "Axe Charge", icon: spellIcons.AXE_CHARGE },
      { name: "Inner Bleeding", icon: spellIcons.INNERBLEEDING },
      { name: "Blade Aura", icon: spellIcons.BLADE_AURA },
    ],
    active3: [
      {
        name: "Crystal Scythe Dash Zone",
        icon: spellIcons.CRYSTAL_SCYTHE_DASH_ZONE,
      },
    ],
    passive1: [
      { name: "Passive Bleedchance", icon: spellIcons.PASSIVE_BLEEDCHANCE },
      {
        name: "Passive Healthchance Axe",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_AXE,
      },
      {
        name: "Passive Armorchance Axe",
        icon: spellIcons.PASSIVE_ARMORCHANCE_AXE,
      },
      {
        name: "Passive Spellpower Chance Axe",
        icon: spellIcons.PASSIVE_SPELLPOWER_CHANCE_AXE,
      },
    ],
  },

  T8_MAIN_MACE: {
    active1: [
      { name: "Defensive Slam", icon: spellIcons.DEFENSIVESLAM },
      { name: "Threatening Smash", icon: spellIcons.THREATENINGSMASH },
      { name: "Sacred Ground", icon: spellIcons.SACRED_GROUND },
    ],
    active2: [
      { name: "Groundshaker", icon: spellIcons.GROUNDSHAKER },
      { name: "Charge Root", icon: spellIcons.CHARGE_ROOT },
      { name: "Guardrune", icon: spellIcons.GUARDRUNE },
      { name: "Pbaoe Pull", icon: spellIcons.PBAOE_PULL },
    ],
    active3: [{ name: "Mace Leap", icon: spellIcons.MACELEAP }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Mace",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_MACE,
      },
      {
        name: "Passive Healthchance Mace",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_MACE,
      },
      {
        name: "Passive Ccduration Chance Mace",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_MACE,
      },
    ],
  },

  T8_2H_MACE: {
    active1: [
      { name: "Defensive Slam", icon: spellIcons.DEFENSIVESLAM },
      { name: "Threatening Smash", icon: spellIcons.THREATENINGSMASH },
      { name: "Sacred Ground", icon: spellIcons.SACRED_GROUND },
    ],
    active2: [
      { name: "Groundshaker", icon: spellIcons.GROUNDSHAKER },
      { name: "Charge Root", icon: spellIcons.CHARGE_ROOT },
      { name: "Guardrune", icon: spellIcons.GUARDRUNE },
      { name: "Pbaoe Pull", icon: spellIcons.PBAOE_PULL },
    ],
    active3: [{ name: "Shriek Mace", icon: spellIcons.SHRIEKMACE }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Mace",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_MACE,
      },
      {
        name: "Passive Healthchance Mace",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_MACE,
      },
      {
        name: "Passive Ccduration Chance Mace",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_MACE,
      },
    ],
  },

  T8_2H_FLAIL: {
    active1: [
      { name: "Defensive Slam", icon: spellIcons.DEFENSIVESLAM },
      { name: "Threatening Smash", icon: spellIcons.THREATENINGSMASH },
      { name: "Sacred Ground", icon: spellIcons.SACRED_GROUND },
    ],
    active2: [
      { name: "Groundshaker", icon: spellIcons.GROUNDSHAKER },
      { name: "Charge Root", icon: spellIcons.CHARGE_ROOT },
      { name: "Guardrune", icon: spellIcons.GUARDRUNE },
      { name: "Pbaoe Pull", icon: spellIcons.PBAOE_PULL },
    ],
    active3: [{ name: "Rootfield", icon: spellIcons.ROOTFIELD }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Mace",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_MACE,
      },
      {
        name: "Passive Healthchance Mace",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_MACE,
      },
      {
        name: "Passive Ccduration Chance Mace",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_MACE,
      },
    ],
  },

  T8_MAIN_ROCKMACE_KEEPER: {
    active1: [
      { name: "Defensive Slam", icon: spellIcons.DEFENSIVESLAM },
      { name: "Threatening Smash", icon: spellIcons.THREATENINGSMASH },
      { name: "Sacred Ground", icon: spellIcons.SACRED_GROUND },
    ],
    active2: [
      { name: "Groundshaker", icon: spellIcons.GROUNDSHAKER },
      { name: "Charge Root", icon: spellIcons.CHARGE_ROOT },
      { name: "Guardrune", icon: spellIcons.GUARDRUNE },
      { name: "Pbaoe Pull", icon: spellIcons.PBAOE_PULL },
    ],
    active3: [{ name: "Primalslam", icon: spellIcons.PRIMALSLAM }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Mace",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_MACE,
      },
      {
        name: "Passive Healthchance Mace",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_MACE,
      },
      {
        name: "Passive Ccduration Chance Mace",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_MACE,
      },
    ],
  },

  T8_MAIN_MACE_HELL: {
    active1: [
      { name: "Defensive Slam", icon: spellIcons.DEFENSIVESLAM },
      { name: "Threatening Smash", icon: spellIcons.THREATENINGSMASH },
      { name: "Sacred Ground", icon: spellIcons.SACRED_GROUND },
    ],
    active2: [
      { name: "Groundshaker", icon: spellIcons.GROUNDSHAKER },
      { name: "Charge Root", icon: spellIcons.CHARGE_ROOT },
      { name: "Guardrune", icon: spellIcons.GUARDRUNE },
      { name: "Pbaoe Pull", icon: spellIcons.PBAOE_PULL },
    ],
    active3: [{ name: "Shrinkingsmash", icon: spellIcons.SHRINKINGSMASH }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Mace",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_MACE,
      },
      {
        name: "Passive Healthchance Mace",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_MACE,
      },
      {
        name: "Passive Ccduration Chance Mace",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_MACE,
      },
    ],
  },

  T8_2H_MACE_MORGANA: {
    active1: [
      { name: "Defensive Slam", icon: spellIcons.DEFENSIVESLAM },
      { name: "Threatening Smash", icon: spellIcons.THREATENINGSMASH },
      { name: "Sacred Ground", icon: spellIcons.SACRED_GROUND },
    ],
    active2: [
      { name: "Groundshaker", icon: spellIcons.GROUNDSHAKER },
      { name: "Charge Root", icon: spellIcons.CHARGE_ROOT },
      { name: "Guardrune", icon: spellIcons.GUARDRUNE },
      { name: "Pbaoe Pull", icon: spellIcons.PBAOE_PULL },
    ],
    active3: [{ name: "Vacuumslash", icon: spellIcons.VACUUMSLASH }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Mace",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_MACE,
      },
      {
        name: "Passive Healthchance Mace",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_MACE,
      },
      {
        name: "Passive Ccduration Chance Mace",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_MACE,
      },
    ],
  },

  T8_2H_DUALMACE_AVALON: {
    active1: [
      { name: "Defensive Slam", icon: spellIcons.DEFENSIVESLAM },
      { name: "Threatening Smash", icon: spellIcons.THREATENINGSMASH },
      { name: "Sacred Ground", icon: spellIcons.SACRED_GROUND },
    ],
    active2: [
      { name: "Groundshaker", icon: spellIcons.GROUNDSHAKER },
      { name: "Charge Root", icon: spellIcons.CHARGE_ROOT },
      { name: "Guardrune", icon: spellIcons.GUARDRUNE },
      { name: "Pbaoe Pull", icon: spellIcons.PBAOE_PULL },
    ],
    active3: [{ name: "Blessed Maces", icon: spellIcons.BLESSED_MACES }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Mace",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_MACE,
      },
      {
        name: "Passive Healthchance Mace",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_MACE,
      },
      {
        name: "Passive Ccduration Chance Mace",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_MACE,
      },
    ],
  },

  T8_MAIN_MACE_CRYSTAL: {
    active1: [
      { name: "Defensive Slam", icon: spellIcons.DEFENSIVESLAM },
      { name: "Threatening Smash", icon: spellIcons.THREATENINGSMASH },
      { name: "Sacred Ground", icon: spellIcons.SACRED_GROUND },
    ],
    active2: [
      { name: "Groundshaker", icon: spellIcons.GROUNDSHAKER },
      { name: "Charge Root", icon: spellIcons.CHARGE_ROOT },
      { name: "Guardrune", icon: spellIcons.GUARDRUNE },
      { name: "Pbaoe Pull", icon: spellIcons.PBAOE_PULL },
    ],
    active3: [
      {
        name: "Mace Crystal Fragment Storm",
        icon: spellIcons.MACE_CRYSTAL_FRAGMENT_STORM,
      },
    ],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Mace",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_MACE,
      },
      {
        name: "Passive Healthchance Mace",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_MACE,
      },
      {
        name: "Passive Ccduration Chance Mace",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_MACE,
      },
    ],
  },

  T8_MAIN_HAMMER: {
    active1: [
      { name: "Hammer Shove", icon: spellIcons.HAMMER_SHOVE },
      {
        name: "Threateningstrike Hammer",
        icon: spellIcons.THREATENINGSTRIKE_HAMMER,
      },
      { name: "Ironbreaker", icon: spellIcons.IRONBREAKER },
    ],
    active2: [
      { name: "Hammer Tremor", icon: spellIcons.HAMMER_TREMOR },
      { name: "Chargeslowae", icon: spellIcons.CHARGESLOWAE },
      { name: "Geyser", icon: spellIcons.GEYSER },
      { name: "Knockout", icon: spellIcons.KNOCKOUT },
      { name: "Tar Ring", icon: spellIcons.TAR_RING },
    ],
    active3: [{ name: "Hammerwhirlwind2", icon: spellIcons.HAMMERWHIRLWIND2 }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Hammer",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HAMMER,
      },
      {
        name: "Passive Healthchance Hammer",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_HAMMER,
      },
      {
        name: "Passive Ccduration Chance Hammer",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_HAMMER,
      },
    ],
  },

  T8_2H_POLEHAMMER: {
    active1: [
      { name: "Hammer Shove", icon: spellIcons.HAMMER_SHOVE },
      {
        name: "Threateningstrike Hammer",
        icon: spellIcons.THREATENINGSTRIKE_HAMMER,
      },
      { name: "Ironbreaker", icon: spellIcons.IRONBREAKER },
    ],
    active2: [
      { name: "Hammer Tremor", icon: spellIcons.HAMMER_TREMOR },
      { name: "Chargeslowae", icon: spellIcons.CHARGESLOWAE },
      { name: "Geyser", icon: spellIcons.GEYSER },
      { name: "Knockout", icon: spellIcons.KNOCKOUT },
      { name: "Tar Ring", icon: spellIcons.TAR_RING },
    ],
    active3: [{ name: "Groundbreaker2", icon: spellIcons.GROUNDBREAKER2 }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Hammer",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HAMMER,
      },
      {
        name: "Passive Healthchance Hammer",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_HAMMER,
      },
      {
        name: "Passive Ccduration Chance Hammer",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_HAMMER,
      },
    ],
  },

  T8_2H_HAMMER: {
    active1: [
      { name: "Hammer Shove", icon: spellIcons.HAMMER_SHOVE },
      {
        name: "Threateningstrike Hammer",
        icon: spellIcons.THREATENINGSTRIKE_HAMMER,
      },
      { name: "Ironbreaker", icon: spellIcons.IRONBREAKER },
    ],
    active2: [
      { name: "Hammer Tremor", icon: spellIcons.HAMMER_TREMOR },
      { name: "Chargeslowae", icon: spellIcons.CHARGESLOWAE },
      { name: "Geyser", icon: spellIcons.GEYSER },
      { name: "Knockout", icon: spellIcons.KNOCKOUT },
      { name: "Tar Ring", icon: spellIcons.TAR_RING },
    ],
    active3: [{ name: "Hammertackle", icon: spellIcons.HAMMERTACKLE }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Hammer",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HAMMER,
      },
      {
        name: "Passive Healthchance Hammer",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_HAMMER,
      },
      {
        name: "Passive Ccduration Chance Hammer",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_HAMMER,
      },
    ],
  },

  T8_2H_HAMMER_UNDEAD: {
    active1: [
      { name: "Hammer Shove", icon: spellIcons.HAMMER_SHOVE },
      {
        name: "Threateningstrike Hammer",
        icon: spellIcons.THREATENINGSTRIKE_HAMMER,
      },
      { name: "Ironbreaker", icon: spellIcons.IRONBREAKER },
    ],
    active2: [
      { name: "Hammer Tremor", icon: spellIcons.HAMMER_TREMOR },
      { name: "Chargeslowae", icon: spellIcons.CHARGESLOWAE },
      { name: "Geyser", icon: spellIcons.GEYSER },
      { name: "Knockout", icon: spellIcons.KNOCKOUT },
      { name: "Tar Ring", icon: spellIcons.TAR_RING },
    ],
    active3: [{ name: "Undeadhand", icon: spellIcons.UNDEADHAND }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Hammer",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HAMMER,
      },
      {
        name: "Passive Healthchance Hammer",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_HAMMER,
      },
      {
        name: "Passive Ccduration Chance Hammer",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_HAMMER,
      },
    ],
  },

  T8_2H_DUALHAMMER_HELL: {
    active1: [
      { name: "Hammer Shove", icon: spellIcons.HAMMER_SHOVE },
      {
        name: "Threateningstrike Hammer",
        icon: spellIcons.THREATENINGSTRIKE_HAMMER,
      },
      { name: "Ironbreaker", icon: spellIcons.IRONBREAKER },
    ],
    active2: [
      { name: "Hammer Tremor", icon: spellIcons.HAMMER_TREMOR },
      { name: "Chargeslowae", icon: spellIcons.CHARGESLOWAE },
      { name: "Geyser", icon: spellIcons.GEYSER },
      { name: "Knockout", icon: spellIcons.KNOCKOUT },
      { name: "Tar Ring", icon: spellIcons.TAR_RING },
    ],
    active3: [{ name: "Giantsteps", icon: spellIcons.GIANTSTEPS }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Hammer",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HAMMER,
      },
      {
        name: "Passive Healthchance Hammer",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_HAMMER,
      },
      {
        name: "Passive Ccduration Chance Hammer",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_HAMMER,
      },
    ],
  },

  T8_2H_RAM_KEEPER: {
    active1: [
      { name: "Hammer Shove", icon: spellIcons.HAMMER_SHOVE },
      {
        name: "Threateningstrike Hammer",
        icon: spellIcons.THREATENINGSTRIKE_HAMMER,
      },
      { name: "Ironbreaker", icon: spellIcons.IRONBREAKER },
    ],
    active2: [
      { name: "Hammer Tremor", icon: spellIcons.HAMMER_TREMOR },
      { name: "Chargeslowae", icon: spellIcons.CHARGESLOWAE },
      { name: "Geyser", icon: spellIcons.GEYSER },
      { name: "Knockout", icon: spellIcons.KNOCKOUT },
      { name: "Tar Ring", icon: spellIcons.TAR_RING },
    ],
    active3: [{ name: "Ram Charge", icon: spellIcons.RAM_CHARGE }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Hammer",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HAMMER,
      },
      {
        name: "Passive Healthchance Hammer",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_HAMMER,
      },
      {
        name: "Passive Ccduration Chance Hammer",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_HAMMER,
      },
    ],
  },

  T8_2H_HAMMER_AVALON: {
    active1: [
      { name: "Hammer Shove", icon: spellIcons.HAMMER_SHOVE },
      {
        name: "Threateningstrike Hammer",
        icon: spellIcons.THREATENINGSTRIKE_HAMMER,
      },
      { name: "Ironbreaker", icon: spellIcons.IRONBREAKER },
    ],
    active2: [
      { name: "Hammer Tremor", icon: spellIcons.HAMMER_TREMOR },
      { name: "Chargeslowae", icon: spellIcons.CHARGESLOWAE },
      { name: "Geyser", icon: spellIcons.GEYSER },
      { name: "Knockout", icon: spellIcons.KNOCKOUT },
      { name: "Tar Ring", icon: spellIcons.TAR_RING },
    ],
    active3: [{ name: "Spinning Smash", icon: spellIcons.SPINNING_SMASH }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Hammer",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HAMMER,
      },
      {
        name: "Passive Healthchance Hammer",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_HAMMER,
      },
      {
        name: "Passive Ccduration Chance Hammer",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_HAMMER,
      },
    ],
  },

  T8_2H_HAMMER_CRYSTAL: {
    active1: [
      { name: "Hammer Shove", icon: spellIcons.HAMMER_SHOVE },
      {
        name: "Threateningstrike Hammer",
        icon: spellIcons.THREATENINGSTRIKE_HAMMER,
      },
      { name: "Ironbreaker", icon: spellIcons.IRONBREAKER },
    ],
    active2: [
      { name: "Hammer Tremor", icon: spellIcons.HAMMER_TREMOR },
      { name: "Chargeslowae", icon: spellIcons.CHARGESLOWAE },
      { name: "Geyser", icon: spellIcons.GEYSER },
      { name: "Knockout", icon: spellIcons.KNOCKOUT },
      { name: "Tar Ring", icon: spellIcons.TAR_RING },
    ],
    active3: [{ name: "Crystalwave", icon: spellIcons.CRYSTALWAVE }],
    passive1: [
      { name: "Passive Stunchance", icon: spellIcons.PASSIVE_STUNCHANCE },
      {
        name: "Passive Energychance Hammer",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_HAMMER,
      },
      {
        name: "Passive Healthchance Hammer",
        icon: spellIcons.PASSIVE_HEALTHCHANCE_HAMMER,
      },
      {
        name: "Passive Ccduration Chance Hammer",
        icon: spellIcons.PASSIVE_CCDURATION_CHANCE_HAMMER,
      },
    ],
  },

  T8_2H_KNUCKLES_SET1: {
    active1: [
      { name: "Create Opening", icon: spellIcons.CREATE_OPENING },
      { name: "Dashkick", icon: spellIcons.DASHKICK },
      { name: "Crossstep Roundhouse", icon: spellIcons.CROSSSTEP_ROUNDHOUSE },
      { name: "Shockwave Punch", icon: spellIcons.SHOCKWAVE_PUNCH },
    ],
    active2: [
      { name: "Triple Kick", icon: spellIcons.TRIPLE_KICK },
      { name: "Backhand Knockback", icon: spellIcons.BACKHAND_KNOCKBACK },
      { name: "Knuckle Counter", icon: spellIcons.KNUCKLE_COUNTER },
      { name: "Knucklecombo", icon: spellIcons.KNUCKLECOMBO },
    ],
    active3: [{ name: "Blazing Geyser", icon: spellIcons.BLAZING_GEYSER }],
    passive1: [
      {
        name: "Passive Knuckle Brawler",
        icon: spellIcons.PASSIVE_KNUCKLE_BRAWLER,
      },
      { name: "Passive Knuckle Rage", icon: spellIcons.PASSIVE_KNUCKLE_RAGE },
      {
        name: "Passive Knuckle Rushdown",
        icon: spellIcons.PASSIVE_KNUCKLE_RUSHDOWN,
      },
      {
        name: "Passive Knuckle Combobreaker",
        icon: spellIcons.PASSIVE_KNUCKLE_COMBOBREAKER,
      },
    ],
  },

  T8_2H_KNUCKLES_SET2: {
    active1: [
      { name: "Create Opening", icon: spellIcons.CREATE_OPENING },
      { name: "Dashkick", icon: spellIcons.DASHKICK },
      { name: "Crossstep Roundhouse", icon: spellIcons.CROSSSTEP_ROUNDHOUSE },
      { name: "Shockwave Punch", icon: spellIcons.SHOCKWAVE_PUNCH },
    ],
    active2: [
      { name: "Triple Kick", icon: spellIcons.TRIPLE_KICK },
      { name: "Backhand Knockback", icon: spellIcons.BACKHAND_KNOCKBACK },
      { name: "Knuckle Counter", icon: spellIcons.KNUCKLE_COUNTER },
      { name: "Knucklecombo", icon: spellIcons.KNUCKLECOMBO },
    ],
    active3: [{ name: "Divepunch Rise", icon: spellIcons.DIVEPUNCH_RISE }],
    passive1: [
      {
        name: "Passive Knuckle Brawler",
        icon: spellIcons.PASSIVE_KNUCKLE_BRAWLER,
      },
      { name: "Passive Knuckle Rage", icon: spellIcons.PASSIVE_KNUCKLE_RAGE },
      {
        name: "Passive Knuckle Rushdown",
        icon: spellIcons.PASSIVE_KNUCKLE_RUSHDOWN,
      },
      {
        name: "Passive Knuckle Combobreaker",
        icon: spellIcons.PASSIVE_KNUCKLE_COMBOBREAKER,
      },
    ],
  },

  T8_2H_KNUCKLES_SET3: {
    active1: [
      { name: "Create Opening", icon: spellIcons.CREATE_OPENING },
      { name: "Dashkick", icon: spellIcons.DASHKICK },
      { name: "Crossstep Roundhouse", icon: spellIcons.CROSSSTEP_ROUNDHOUSE },
      { name: "Shockwave Punch", icon: spellIcons.SHOCKWAVE_PUNCH },
    ],
    active2: [
      { name: "Triple Kick", icon: spellIcons.TRIPLE_KICK },
      { name: "Backhand Knockback", icon: spellIcons.BACKHAND_KNOCKBACK },
      { name: "Knuckle Counter", icon: spellIcons.KNUCKLE_COUNTER },
      { name: "Knucklecombo", icon: spellIcons.KNUCKLECOMBO },
    ],
    active3: [{ name: "Impulse Punch", icon: spellIcons.IMPULSE_PUNCH }],
    passive1: [
      {
        name: "Passive Knuckle Brawler",
        icon: spellIcons.PASSIVE_KNUCKLE_BRAWLER,
      },
      { name: "Passive Knuckle Rage", icon: spellIcons.PASSIVE_KNUCKLE_RAGE },
      {
        name: "Passive Knuckle Rushdown",
        icon: spellIcons.PASSIVE_KNUCKLE_RUSHDOWN,
      },
      {
        name: "Passive Knuckle Combobreaker",
        icon: spellIcons.PASSIVE_KNUCKLE_COMBOBREAKER,
      },
    ],
  },

  T8_2H_KNUCKLES_KEEPER: {
    active1: [
      { name: "Create Opening", icon: spellIcons.CREATE_OPENING },
      { name: "Dashkick", icon: spellIcons.DASHKICK },
      { name: "Crossstep Roundhouse", icon: spellIcons.CROSSSTEP_ROUNDHOUSE },
      { name: "Shockwave Punch", icon: spellIcons.SHOCKWAVE_PUNCH },
    ],
    active2: [
      { name: "Triple Kick", icon: spellIcons.TRIPLE_KICK },
      { name: "Backhand Knockback", icon: spellIcons.BACKHAND_KNOCKBACK },
      { name: "Knuckle Counter", icon: spellIcons.KNUCKLE_COUNTER },
      { name: "Knucklecombo", icon: spellIcons.KNUCKLECOMBO },
    ],
    active3: [
      { name: "Pummeling Strikes", icon: spellIcons.PUMMELING_STRIKES },
    ],
    passive1: [
      {
        name: "Passive Knuckle Brawler",
        icon: spellIcons.PASSIVE_KNUCKLE_BRAWLER,
      },
      { name: "Passive Knuckle Rage", icon: spellIcons.PASSIVE_KNUCKLE_RAGE },
      {
        name: "Passive Knuckle Rushdown",
        icon: spellIcons.PASSIVE_KNUCKLE_RUSHDOWN,
      },
      {
        name: "Passive Knuckle Combobreaker",
        icon: spellIcons.PASSIVE_KNUCKLE_COMBOBREAKER,
      },
    ],
  },

  T8_2H_KNUCKLES_HELL: {
    active1: [
      { name: "Create Opening", icon: spellIcons.CREATE_OPENING },
      { name: "Dashkick", icon: spellIcons.DASHKICK },
      { name: "Crossstep Roundhouse", icon: spellIcons.CROSSSTEP_ROUNDHOUSE },
      { name: "Shockwave Punch", icon: spellIcons.SHOCKWAVE_PUNCH },
    ],
    active2: [
      { name: "Triple Kick", icon: spellIcons.TRIPLE_KICK },
      { name: "Backhand Knockback", icon: spellIcons.BACKHAND_KNOCKBACK },
      { name: "Knuckle Counter", icon: spellIcons.KNUCKLE_COUNTER },
      { name: "Knucklecombo", icon: spellIcons.KNUCKLECOMBO },
    ],
    active3: [{ name: "Boulder Toss", icon: spellIcons.BOULDER_TOSS }],
    passive1: [
      {
        name: "Passive Knuckle Brawler",
        icon: spellIcons.PASSIVE_KNUCKLE_BRAWLER,
      },
      { name: "Passive Knuckle Rage", icon: spellIcons.PASSIVE_KNUCKLE_RAGE },
      {
        name: "Passive Knuckle Rushdown",
        icon: spellIcons.PASSIVE_KNUCKLE_RUSHDOWN,
      },
      {
        name: "Passive Knuckle Combobreaker",
        icon: spellIcons.PASSIVE_KNUCKLE_COMBOBREAKER,
      },
    ],
  },

  T8_2H_KNUCKLES_MORGANA: {
    active1: [
      { name: "Create Opening", icon: spellIcons.CREATE_OPENING },
      { name: "Dashkick", icon: spellIcons.DASHKICK },
      { name: "Crossstep Roundhouse", icon: spellIcons.CROSSSTEP_ROUNDHOUSE },
      { name: "Shockwave Punch", icon: spellIcons.SHOCKWAVE_PUNCH },
    ],
    active2: [
      { name: "Triple Kick", icon: spellIcons.TRIPLE_KICK },
      { name: "Backhand Knockback", icon: spellIcons.BACKHAND_KNOCKBACK },
      { name: "Knuckle Counter", icon: spellIcons.KNUCKLE_COUNTER },
      { name: "Knucklecombo", icon: spellIcons.KNUCKLECOMBO },
    ],
    active3: [{ name: "Growing Punch", icon: spellIcons.GROWING_PUNCH }],
    passive1: [
      {
        name: "Passive Knuckle Brawler",
        icon: spellIcons.PASSIVE_KNUCKLE_BRAWLER,
      },
      { name: "Passive Knuckle Rage", icon: spellIcons.PASSIVE_KNUCKLE_RAGE },
      {
        name: "Passive Knuckle Rushdown",
        icon: spellIcons.PASSIVE_KNUCKLE_RUSHDOWN,
      },
      {
        name: "Passive Knuckle Combobreaker",
        icon: spellIcons.PASSIVE_KNUCKLE_COMBOBREAKER,
      },
    ],
  },

  T8_2H_KNUCKLES_AVALON: {
    active1: [
      { name: "Create Opening", icon: spellIcons.CREATE_OPENING },
      { name: "Dashkick", icon: spellIcons.DASHKICK },
      { name: "Crossstep Roundhouse", icon: spellIcons.CROSSSTEP_ROUNDHOUSE },
      { name: "Shockwave Punch", icon: spellIcons.SHOCKWAVE_PUNCH },
    ],
    active2: [
      { name: "Triple Kick", icon: spellIcons.TRIPLE_KICK },
      { name: "Backhand Knockback", icon: spellIcons.BACKHAND_KNOCKBACK },
      { name: "Knuckle Counter", icon: spellIcons.KNUCKLE_COUNTER },
      { name: "Knucklecombo", icon: spellIcons.KNUCKLECOMBO },
    ],
    active3: [
      { name: "Triplecombo Divekick", icon: spellIcons.TRIPLECOMBO_DIVEKICK },
    ],
    passive1: [
      {
        name: "Passive Knuckle Brawler",
        icon: spellIcons.PASSIVE_KNUCKLE_BRAWLER,
      },
      { name: "Passive Knuckle Rage", icon: spellIcons.PASSIVE_KNUCKLE_RAGE },
      {
        name: "Passive Knuckle Rushdown",
        icon: spellIcons.PASSIVE_KNUCKLE_RUSHDOWN,
      },
      {
        name: "Passive Knuckle Combobreaker",
        icon: spellIcons.PASSIVE_KNUCKLE_COMBOBREAKER,
      },
    ],
  },

  T8_2H_KNUCKLES_CRYSTAL: {
    active1: [
      { name: "Create Opening", icon: spellIcons.CREATE_OPENING },
      { name: "Dashkick", icon: spellIcons.DASHKICK },
      { name: "Crossstep Roundhouse", icon: spellIcons.CROSSSTEP_ROUNDHOUSE },
      { name: "Shockwave Punch", icon: spellIcons.SHOCKWAVE_PUNCH },
    ],
    active2: [
      { name: "Triple Kick", icon: spellIcons.TRIPLE_KICK },
      { name: "Backhand Knockback", icon: spellIcons.BACKHAND_KNOCKBACK },
      { name: "Knuckle Counter", icon: spellIcons.KNUCKLE_COUNTER },
      { name: "Knucklecombo", icon: spellIcons.KNUCKLECOMBO },
    ],
    active3: [{ name: "Conepunch 2", icon: spellIcons.CONEPUNCH2 }],
    passive1: [
      {
        name: "Passive Knuckle Brawler",
        icon: spellIcons.PASSIVE_KNUCKLE_BRAWLER,
      },
      { name: "Passive Knuckle Rage", icon: spellIcons.PASSIVE_KNUCKLE_RAGE },
      {
        name: "Passive Knuckle Rushdown",
        icon: spellIcons.PASSIVE_KNUCKLE_RUSHDOWN,
      },
      {
        name: "Passive Knuckle Combobreaker",
        icon: spellIcons.PASSIVE_KNUCKLE_COMBOBREAKER,
      },
    ],
  },

  T8_2H_CROSSBOW: {
    active1: [
      { name: "Autofire 2", icon: spellIcons.AUTOFIRE2 },
      { name: "Bolt Shot", icon: spellIcons.BOLTSHOT },
    ],
    active2: [
      { name: "Knockback Shot 2", icon: spellIcons.KNOCKBACKSHOT2 },
      { name: "Sunder Shot", icon: spellIcons.SUNDERSHOT },
      { name: "Caltrops", icon: spellIcons.CALTROPS },
      { name: "Silencing Bolt", icon: spellIcons.SILENCINGBOLT },
    ],
    active3: [
      { name: "Snipeshot Crossbow", icon: spellIcons.SNIPESHOT_CROSSBOW },
    ],
    passive1: [
      {
        name: "Passive Knockbackchance",
        icon: spellIcons.PASSIVE_KNOCKBACKCHANCE,
      },
      { name: "Passive CD Reset Q", icon: spellIcons.PASSIVE_CD_RESET_Q },
      {
        name: "Passive Energychance Crossbow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CROSSBOW,
      },
      {
        name: "Passive Spellpower Caster Crossbow",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CROSSBOW,
      },
    ],
  },

  T8_2H_CROSSBOWLARGE: {
    active1: [
      { name: "Autofire 2", icon: spellIcons.AUTOFIRE2 },
      { name: "Bolt Shot", icon: spellIcons.BOLTSHOT },
    ],
    active2: [
      { name: "Knockback Shot 2", icon: spellIcons.KNOCKBACKSHOT2 },
      { name: "Sunder Shot", icon: spellIcons.SUNDERSHOT },
      { name: "Caltrops", icon: spellIcons.CALTROPS },
      { name: "Silencing Bolt", icon: spellIcons.SILENCINGBOLT },
    ],
    active3: [
      { name: "Crossbow Armorpiercer", icon: spellIcons.CROSSBOW_ARMORPIERCER },
    ],
    passive1: [
      {
        name: "Passive Knockbackchance",
        icon: spellIcons.PASSIVE_KNOCKBACKCHANCE,
      },
      { name: "Passive CD Reset Q", icon: spellIcons.PASSIVE_CD_RESET_Q },
      {
        name: "Passive Energychance Crossbow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CROSSBOW,
      },
      {
        name: "Passive Spellpower Caster Crossbow",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CROSSBOW,
      },
    ],
  },

  T8_MAIN_1HCROSSBOW: {
    active1: [
      { name: "Autofire 2", icon: spellIcons.AUTOFIRE2 },
      { name: "Bolt Shot", icon: spellIcons.BOLTSHOT },
    ],
    active2: [
      { name: "Knockback Shot 2", icon: spellIcons.KNOCKBACKSHOT2 },
      { name: "Sunder Shot", icon: spellIcons.SUNDERSHOT },
      { name: "Caltrops", icon: spellIcons.CALTROPS },
      { name: "Silencing Bolt", icon: spellIcons.SILENCINGBOLT },
    ],
    active3: [{ name: "Exploding Shot", icon: spellIcons.EXPLODING_SHOT }],
    passive1: [
      {
        name: "Passive Knockbackchance",
        icon: spellIcons.PASSIVE_KNOCKBACKCHANCE,
      },
      { name: "Passive CD Reset Q", icon: spellIcons.PASSIVE_CD_RESET_Q },
      {
        name: "Passive Energychance Crossbow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CROSSBOW,
      },
      {
        name: "Passive Spellpower Caster Crossbow",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CROSSBOW,
      },
    ],
  },

  T8_2H_REPEATINGCROSSBOW_UNDEAD: {
    active1: [
      { name: "Autofire 2", icon: spellIcons.AUTOFIRE2 },
      { name: "Bolt Shot", icon: spellIcons.BOLTSHOT },
    ],
    active2: [
      { name: "Knockback Shot 2", icon: spellIcons.KNOCKBACKSHOT2 },
      { name: "Sunder Shot", icon: spellIcons.SUNDERSHOT },
      { name: "Caltrops", icon: spellIcons.CALTROPS },
      { name: "Silencing Bolt", icon: spellIcons.SILENCINGBOLT },
    ],
    active3: [{ name: "Ground Mine", icon: spellIcons.GROUNDMINE }],
    passive1: [
      {
        name: "Passive Knockbackchance",
        icon: spellIcons.PASSIVE_KNOCKBACKCHANCE,
      },
      { name: "Passive CD Reset Q", icon: spellIcons.PASSIVE_CD_RESET_Q },
      {
        name: "Passive Energychance Crossbow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CROSSBOW,
      },
      {
        name: "Passive Spellpower Caster Crossbow",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CROSSBOW,
      },
    ],
  },

  T8_2H_DUALCROSSBOW_HELL: {
    active1: [
      { name: "Autofire 2", icon: spellIcons.AUTOFIRE2 },
      { name: "Bolt Shot", icon: spellIcons.BOLTSHOT },
    ],
    active2: [
      { name: "Knockback Shot 2", icon: spellIcons.KNOCKBACKSHOT2 },
      { name: "Sunder Shot", icon: spellIcons.SUNDERSHOT },
      { name: "Caltrops", icon: spellIcons.CALTROPS },
      { name: "Silencing Bolt", icon: spellIcons.SILENCINGBOLT },
    ],
    active3: [{ name: "Dual Rapidfire", icon: spellIcons.DUAL_RAPIDFIRE }],
    passive1: [
      {
        name: "Passive Knockbackchance",
        icon: spellIcons.PASSIVE_KNOCKBACKCHANCE,
      },
      { name: "Passive CD Reset Q", icon: spellIcons.PASSIVE_CD_RESET_Q },
      {
        name: "Passive Energychance Crossbow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CROSSBOW,
      },
      {
        name: "Passive Spellpower Caster Crossbow",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CROSSBOW,
      },
    ],
  },

  T8_2H_CROSSBOWLARGE_MORGANA: {
    active1: [
      { name: "Autofire 2", icon: spellIcons.AUTOFIRE2 },
      { name: "Bolt Shot", icon: spellIcons.BOLTSHOT },
    ],
    active2: [
      { name: "Knockback Shot 2", icon: spellIcons.KNOCKBACKSHOT2 },
      { name: "Sunder Shot", icon: spellIcons.SUNDERSHOT },
      { name: "Caltrops", icon: spellIcons.CALTROPS },
      { name: "Silencing Bolt", icon: spellIcons.SILENCINGBOLT },
    ],
    active3: [
      {
        name: "Crossbow Cone Ultimate",
        icon: spellIcons.CROSSBOW_CONE_ULTIMATE,
      },
    ],
    passive1: [
      {
        name: "Passive Knockbackchance",
        icon: spellIcons.PASSIVE_KNOCKBACKCHANCE,
      },
      { name: "Passive CD Reset Q", icon: spellIcons.PASSIVE_CD_RESET_Q },
      {
        name: "Passive Energychance Crossbow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CROSSBOW,
      },
      {
        name: "Passive Spellpower Caster Crossbow",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CROSSBOW,
      },
    ],
  },

  T8_2H_CROSSBOW_CANNON_AVALON: {
    active1: [
      { name: "Autofire 2", icon: spellIcons.AUTOFIRE2 },
      { name: "Bolt Shot", icon: spellIcons.BOLTSHOT },
    ],
    active2: [
      { name: "Knockback Shot 2", icon: spellIcons.KNOCKBACKSHOT2 },
      { name: "Sunder Shot", icon: spellIcons.SUNDERSHOT },
      { name: "Caltrops", icon: spellIcons.CALTROPS },
      { name: "Silencing Bolt", icon: spellIcons.SILENCINGBOLT },
    ],
    active3: [
      { name: "Crossbow Divine Shot", icon: spellIcons.CROSSBOW_DIVINE_SHOT },
    ],
    passive1: [
      {
        name: "Passive Knockbackchance",
        icon: spellIcons.PASSIVE_KNOCKBACKCHANCE,
      },
      { name: "Passive CD Reset Q", icon: spellIcons.PASSIVE_CD_RESET_Q },
      {
        name: "Passive Energychance Crossbow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CROSSBOW,
      },
      {
        name: "Passive Spellpower Caster Crossbow",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CROSSBOW,
      },
    ],
  },

  T8_2H_DUALCROSSBOW_CRYSTAL: {
    active1: [
      { name: "Autofire 2", icon: spellIcons.AUTOFIRE2 },
      { name: "Bolt Shot", icon: spellIcons.BOLTSHOT },
    ],
    active2: [
      { name: "Knockback Shot 2", icon: spellIcons.KNOCKBACKSHOT2 },
      { name: "Sunder Shot", icon: spellIcons.SUNDERSHOT },
      { name: "Caltrops", icon: spellIcons.CALTROPS },
      { name: "Silencing Bolt", icon: spellIcons.SILENCINGBOLT },
    ],
    active3: [{ name: "Crystal Xbow", icon: spellIcons.CRYSTALXBOW }],
    passive1: [
      {
        name: "Passive Knockbackchance",
        icon: spellIcons.PASSIVE_KNOCKBACKCHANCE,
      },
      { name: "Passive CD Reset Q", icon: spellIcons.PASSIVE_CD_RESET_Q },
      {
        name: "Passive Energychance Crossbow",
        icon: spellIcons.PASSIVE_ENERGYCHANCE_CROSSBOW,
      },
      {
        name: "Passive Spellpower Caster Crossbow",
        icon: spellIcons.PASSIVE_SPELLPOWER_CASTER_CROSSBOW,
      },
    ],
  },
};

export default spellDB;
